
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("c8BWz", function(module, exports) {
$parcel$export(module.exports, "EmptyTocItem", () => (parcelRequire("8Utl8")).EmptyTocItem);

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3u5lg = parcelRequire("3u5lg");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6mKj3 = parcelRequire("6mKj3");


var $6mEZ3 = parcelRequire("6mEZ3");


var $5kjCz = parcelRequire("5kjCz");


var $JbVPK = parcelRequire("JbVPK");


var $bX5uj = parcelRequire("bX5uj");


var $e4o8D = parcelRequire("e4o8D");


var $3jwuS = parcelRequire("3jwuS");










var $9aYkv = parcelRequire("9aYkv");


var $d3Yd3 = parcelRequire("d3Yd3");

const $bae8eba0391a5294$var$TocSpan = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        const { prop: prop, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg20Hp",
            __cmplp.prop.outline === "true" || __cmplp.prop.display === "true" ? "_3iDTPbS8kF" : "_3iDTPbYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $bae8eba0391a5294$var$ItemAnchor = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg20Hp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $bae8eba0391a5294$var$ListItem = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "li" : t2;
        const { listStyle: listStyle, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1vjxhb3": (0, $9aYkv.default)(__cmplp.listStyle)
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1LMyvKL7Tp",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $bae8eba0391a5294$export$a51ac23f8f2bec4c = 'toc-item-body';
const $bae8eba0391a5294$export$d9f23a508df4a861 = (element, outline, shouldExpandParentExpandsOnScroll = false)=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: "toc-item-body",
        "data-outline": element.outline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bae8eba0391a5294$var$TocSpan, {
        prop: {
            display: '',
            outline: outline
        }
    }, element.outline, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bae8eba0391a5294$var$ItemAnchor, {
        href: element.link,
        onClick: ()=>(0, $d3Yd3.scrollToHeader)(element.link, shouldExpandParentExpandsOnScroll),
        "data-testid": $bae8eba0391a5294$export$a51ac23f8f2bec4c,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "toc-link"
    }, element.innerContent)));
};
const $bae8eba0391a5294$export$f21f23352126117a = 'list-style-toc-level-container';
const $bae8eba0391a5294$export$cac47b1ba5f92468 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, prop: prop } = t0;
    const t1 = prop?.csslistindent;
    let t2;
    if ($[0] !== t1) {
        t2 = {
            paddingLeft: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            "data-testid": $bae8eba0391a5294$export$f21f23352126117a,
            style: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
const $bae8eba0391a5294$export$6e7eafba84a66a80 = 'list-style-toc-item-container';
const $bae8eba0391a5294$export$9b4f02b15f3133b5 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, prop: prop, link: link } = t0;
    let listStyle;
    if (link === "toc-empty-item") listStyle = "none";
    else listStyle = prop?.cssliststyle ?? "default";
    let t1;
    if ($[0] !== children || $[1] !== listStyle) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bae8eba0391a5294$var$ListItem, {
            "data-testid": $bae8eba0391a5294$export$6e7eafba84a66a80,
            listStyle: listStyle
        }, children);
        $[0] = children;
        $[1] = listStyle;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $bae8eba0391a5294$export$7186da1cdf210be9 = 'flat-style-toc-item-container';
const $bae8eba0391a5294$export$127d6feb1b4cbb5f = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": $bae8eba0391a5294$export$7186da1cdf210be9,
            className: "toc-item-container"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $bae8eba0391a5294$export$e63da11b221387fa = (prop)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            display: "true"
        };
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== prop.separator) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bae8eba0391a5294$var$TocSpan, {
            className: "toc-separator",
            prop: t0
        }, prop.separator);
        $[1] = prop.separator;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};



var $8Utl8 = parcelRequire("8Utl8");


var $f8dGE = parcelRequire("f8dGE");


var $jTt8P = parcelRequire("jTt8P");





var $7W8i8 = parcelRequire("7W8i8");


var $202oG = parcelRequire("202oG");

const $1091a8df710790c5$var$logger = (0, $7W8i8.getLogger)('table-of-contents');
const $1091a8df710790c5$var$INCLUDED_CONTENT_EXTENSION_KEYS = new Set([
    'excerpt-include',
    'include-page',
    'include'
]);
const $1091a8df710790c5$var$EXCERPT_EXTENSION_KEY = 'excerpt';
const $1091a8df710790c5$var$INCLUDED_HEADING_ID_DELIMITER = '-';
/**
 * Module-level WeakMap cache so multiple TOC macros on the same page share
 * a single ADF traversal.
 */ const $1091a8df710790c5$var$headingsCache = new WeakMap();
const $1091a8df710790c5$var$buildCacheKey = (minConfig, maxConfig, includeRegex, excludeRegex, includeIncludedContent)=>`${minConfig}|${maxConfig}|${includeRegex ?? ''}|${excludeRegex ?? ''}|${includeIncludedContent ? 1 : 0}`;
const $1091a8df710790c5$var$getMacroParams = (node)=>node?.attrs?.parameters?.macroParams;
const $1091a8df710790c5$var$getParamValue = (macroParams, paramName)=>macroParams?.[paramName]?.value?.trim() || undefined;
const $1091a8df710790c5$var$getMacroId = (node)=>node?.attrs?.parameters?.macroMetadata?.macroId?.value || node?.attrs?.localId;
const $1091a8df710790c5$var$extractContentIdFromTypedValue = (value)=>value.match(/confluence-content:\/\/[^/]+\/(\d+)/)?.[1];
const $1091a8df710790c5$var$parseLegacyLocation = (location)=>{
    if (!location) return {};
    const colonIdx = location.indexOf(':');
    if (colonIdx > 0) return {
        spaceKey: location.slice(0, colonIdx).trim() || undefined,
        pageTitle: location.slice(colonIdx + 1).trim() || undefined
    };
    return {
        pageTitle: location.trim() || undefined
    };
};
const $1091a8df710790c5$var$buildIncludedContentKey = ({ extensionKey: extensionKey, contentId: contentId, spaceKey: spaceKey, pageTitle: pageTitle, excerptName: excerptName })=>[
        extensionKey,
        contentId ?? '',
        spaceKey ?? '',
        pageTitle ?? '',
        excerptName ?? ''
    ].join('|');
const $1091a8df710790c5$var$isIncludedContentNode = (node)=>$1091a8df710790c5$var$INCLUDED_CONTENT_EXTENSION_KEYS.has(node?.attrs?.extensionKey);
const $1091a8df710790c5$export$f71b79b59202ebab = (macroId, headingId)=>headingId ? `${macroId}${$1091a8df710790c5$var$INCLUDED_HEADING_ID_DELIMITER}${headingId}` : undefined;
const $1091a8df710790c5$var$extractIncludedContentReferenceFromNode = (node, defaultSpaceKey, parentContentId)=>{
    const extensionKey = node?.attrs?.extensionKey;
    if (extensionKey !== 'excerpt-include' && extensionKey !== 'include-page' && extensionKey !== 'include') return undefined;
    const macroId = $1091a8df710790c5$var$getMacroId(node);
    if (!macroId) return undefined;
    const macroParams = $1091a8df710790c5$var$getMacroParams(node);
    const referencedContentId = $1091a8df710790c5$var$getParamValue(macroParams, '_referencedContentId');
    const typedTarget = $1091a8df710790c5$var$getParamValue(macroParams, '');
    const contentId = referencedContentId || typedTarget && $1091a8df710790c5$var$extractContentIdFromTypedValue(typedTarget);
    const legacyTarget = extensionKey === 'include-page' || extensionKey === 'include' ? $1091a8df710790c5$var$getParamValue(macroParams, 'pageTitle') || $1091a8df710790c5$var$getParamValue(macroParams, '0') || typedTarget : typedTarget || $1091a8df710790c5$var$getParamValue(macroParams, '0');
    const parsedLegacyTarget = $1091a8df710790c5$var$parseLegacyLocation(legacyTarget);
    const spaceKey = $1091a8df710790c5$var$getParamValue(macroParams, 'spaceKey') || parsedLegacyTarget.spaceKey || defaultSpaceKey;
    const pageTitle = parsedLegacyTarget.pageTitle;
    const excerptName = extensionKey === 'excerpt-include' ? $1091a8df710790c5$var$getParamValue(macroParams, 'name') : undefined;
    if (!contentId && !pageTitle) return undefined;
    const key = $1091a8df710790c5$var$buildIncludedContentKey({
        extensionKey: extensionKey,
        contentId: contentId,
        spaceKey: spaceKey,
        pageTitle: pageTitle,
        excerptName: excerptName
    });
    return {
        key: key,
        extensionKey: extensionKey,
        macroId: macroId,
        contentId: contentId,
        spaceKey: spaceKey,
        hostSpaceKey: defaultSpaceKey,
        pageTitle: pageTitle,
        excerptName: excerptName,
        parentContentId: parentContentId,
        extensionType: node?.attrs?.extensionType,
        nodeType: node?.type,
        macroMetadata: node?.attrs?.parameters?.macroMetadata,
        macroParams: macroParams
    };
};
const $1091a8df710790c5$export$8235d87af2537ef3 = (adf, defaultSpaceKey, parentContentId)=>{
    let adfObject = adf;
    if (typeof adf === 'string') try {
        adfObject = JSON.parse(adf);
    } catch  {
        return [];
    }
    const referencesByKey = new Map();
    (0, $jTt8P.traverse)(adfObject || {}, {
        extension: (node)=>{
            if ($1091a8df710790c5$export$37241f8687703633(node)) return;
            const reference = $1091a8df710790c5$var$extractIncludedContentReferenceFromNode(node, defaultSpaceKey, parentContentId);
            if (reference) referencesByKey.set(reference.key, reference);
        },
        bodiedExtension: (node)=>{
            if ($1091a8df710790c5$export$37241f8687703633(node)) return;
            const reference = $1091a8df710790c5$var$extractIncludedContentReferenceFromNode(node, defaultSpaceKey, parentContentId);
            if (reference) referencesByKey.set(reference.key, reference);
        }
    });
    return Array.from(referencesByKey.values());
};
const $1091a8df710790c5$export$37241f8687703633 = (node)=>{
    const macroOutput = node?.attrs?.parameters?.macroOutput;
    if (typeof macroOutput !== 'string') return undefined;
    try {
        const parsedMacroOutput = JSON.parse(macroOutput);
        return parsedMacroOutput.content || [];
    } catch (error) {
        $1091a8df710790c5$var$logger.error`Failed to parse included content macro output for TOC - ${error}`;
        return undefined;
    }
};
const $1091a8df710790c5$export$9f28523e22d9b3e2 = (adfObject, excerptName)=>{
    const excerptContent = [];
    let foundExcerpt = false;
    (0, $jTt8P.traverse)(adfObject || {}, {
        bodiedExtension: (node)=>{
            if (foundExcerpt || node?.attrs?.extensionKey !== $1091a8df710790c5$var$EXCERPT_EXTENSION_KEY) return;
            const nodeExcerptName = $1091a8df710790c5$var$getParamValue($1091a8df710790c5$var$getMacroParams(node), 'name');
            if (excerptName && nodeExcerptName !== excerptName) return;
            foundExcerpt = true;
            excerptContent.push(...node.content || []);
        }
    });
    return excerptContent;
};
const $1091a8df710790c5$export$bebd062f3d239910 = (macroNode, adf, includedContentMap, defaultSpaceKey, includeIncludedContent = false)=>{
    const minConfig = Math.max(1, parseInt(macroNode?.attrs?.parameters?.macroParams?.minLevel?.value) || 1);
    const maxConfig = Math.min(6, parseInt(macroNode?.attrs?.parameters?.macroParams?.maxLevel?.value) || 6);
    const macroParams = macroNode?.attrs?.parameters?.macroParams;
    const includeheaderregex = macroParams?.include?.value;
    const excludeheaderregex = macroParams?.exclude?.value;
    // Helper function to go through heading content
    // and test regular expression against texts from content
    function filterHeadingWithRegex(node) {
        if (!node?.content) return false;
        if (!includeheaderregex && !excludeheaderregex) return true;
        try {
            let includeRegex;
            if (includeheaderregex) includeRegex = new RegExp(includeheaderregex);
            let excludeRegex;
            if (excludeheaderregex) excludeRegex = new RegExp(excludeheaderregex);
            let fullHeaderString = '';
            for (const el of node?.content)fullHeaderString += el?.text || el?.attrs?.text || el?.attrs?.__confluenceMetadata?.contentTitle || '';
            if (includeRegex && !includeRegex.test(fullHeaderString)) return false;
            if (excludeRegex && excludeRegex.test(fullHeaderString)) return false;
        } catch (error) {
            $1091a8df710790c5$var$logger.error`Failed to handle regular expression - ${error}`;
        }
        return true;
    }
    // Hold a list of headers to look for duplicates
    // duplicated headers require an additional index/key which appends the link
    const headingsIds = new Set();
    // NOTE: ADFNode and ADFEntity share the same shape but ADFEntity allows for more keys
    let adfObject = adf;
    if (typeof adf === 'string') try {
        adfObject = JSON.parse(adf);
    } catch  {
    // Swallow the error as ADF format error handling is expected to be done earlier,
    // in the component that renders the entire content
    }
    const adfWasString = typeof adf === 'string';
    const headerelements = $1091a8df710790c5$var$buildHeadings((0, $6mKj3.expVal)('confluence_toc_render_perf', 'isEnabled', false), {
        adfObject: adfObject,
        adfWasString: adfWasString,
        minConfig: minConfig,
        maxConfig: maxConfig,
        includeheaderregex: includeheaderregex,
        excludeheaderregex: excludeheaderregex,
        headingsIds: headingsIds,
        filterHeadingWithRegex: filterHeadingWithRegex,
        includedContentMap: includedContentMap,
        defaultSpaceKey: defaultSpaceKey,
        includeIncludedContent: includeIncludedContent
    });
    return {
        className: `${macroParams?.class?.value || 'macro-core'} toc-macro conf-macro output-block`,
        cssliststyle: macroParams?.style?.value,
        csslistindent: macroParams?.indent?.value,
        separators: macroParams?.separator?.value,
        headerelements: headerelements,
        headerRange: [
            'H1',
            'H2',
            'H3',
            'H4',
            'H5',
            'H6'
        ].slice(minConfig - 1, maxConfig),
        hasbody: macroNode?.attrs.bodyType === 'none' ? 'false' : 'true',
        name: macroNode?.attrs?.extensionKey,
        structure: macroParams?.type?.value,
        outline: macroParams?.outline?.value,
        printable: macroParams?.printable?.value || 'true',
        macroId: macroNode?.attrs?.parameters?.macroMetadata?.macroId?.value
    };
};
const $1091a8df710790c5$var$buildHeadings = (usePerfPath, { adfObject: adfObject, adfWasString: adfWasString, minConfig: minConfig, maxConfig: maxConfig, includeheaderregex: includeheaderregex, excludeheaderregex: excludeheaderregex, headingsIds: headingsIds, filterHeadingWithRegex: filterHeadingWithRegex, includedContentMap: includedContentMap, defaultSpaceKey: defaultSpaceKey, includeIncludedContent: includeIncludedContent = false })=>{
    const headingElements = [];
    let cachedHeadings;
    let cacheBucket;
    let cacheKey;
    const hasIncludedContent = Boolean(includedContentMap?.size);
    if (adfObject && typeof adfObject === 'object' && !adfWasString && usePerfPath && !hasIncludedContent) {
        cacheKey = $1091a8df710790c5$var$buildCacheKey(minConfig, maxConfig, includeheaderregex, excludeheaderregex, includeIncludedContent);
        cacheBucket = $1091a8df710790c5$var$headingsCache.get(adfObject);
        if (!cacheBucket) {
            cacheBucket = new Map();
            $1091a8df710790c5$var$headingsCache.set(adfObject, cacheBucket);
        }
        cachedHeadings = cacheBucket.get(cacheKey);
    }
    if (cachedHeadings) {
        // Push cached entries; downstream code mutates the array but not its members.
        headingElements.push(...cachedHeadings);
        return headingElements;
    }
    const pushHeading = (node, activeHeadingIds, parentMacroId)=>{
        if (filterHeadingWithRegex(node)) {
            let clone;
            const headingId = (0, $202oG.getHeadingId)(node, activeHeadingIds);
            const id = parentMacroId ? $1091a8df710790c5$export$f71b79b59202ebab(parentMacroId, headingId) : headingId;
            if (usePerfPath) // Shallow clone is sufficient: we only assign attrs.id, and downstream consumers
            // (MiniRenderer / renderContent) only READ node.content. This avoids the
            // expensive deep clone of the whole heading subtree
            clone = {
                ...node,
                attrs: {
                    ...node.attrs,
                    id: id
                }
            };
            else {
                // init deep-copy node
                clone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(node);
                clone.attrs = clone.attrs || {};
                clone.attrs.id = id;
            }
            if (node?.attrs?.level >= minConfig && node?.attrs?.level <= maxConfig) headingElements.push(clone);
        }
    };
    const getIncludedContentForNode = (node)=>{
        // Gated behind the `confluence_toc_included_content_exp` experiment. When it
        // is off we must ignore BOTH sources of included headings: the pre-rendered `macroOutput`
        // baked into published/SSR ADF, and the live-resolved `includedContentMap`.
        if (!includeIncludedContent) return undefined;
        const macroOutputContent = $1091a8df710790c5$export$37241f8687703633(node);
        if (macroOutputContent) return macroOutputContent;
        const includedContentReference = $1091a8df710790c5$var$extractIncludedContentReferenceFromNode(node, defaultSpaceKey);
        return includedContentReference ? includedContentMap?.get(includedContentReference.key) : undefined;
    };
    // Create a reusable visitor collection that can handle both headings and extensions (LCMs)
    const createVisitors = (parentMacroId, activeHeadingIds = headingsIds)=>({
            heading: (node)=>{
                pushHeading(node, activeHeadingIds, parentMacroId);
            },
            // Traverse into extension nodes (Legacy Content Macros) to find nested headings
            extension: (node)=>{
                const includedContentReference = $1091a8df710790c5$var$extractIncludedContentReferenceFromNode(node, defaultSpaceKey);
                const includedContent = getIncludedContentForNode(node);
                const includedContentMacroId = includedContentReference?.macroId || $1091a8df710790c5$var$getMacroId(node);
                if (includedContent && includedContentMacroId) (0, $jTt8P.traverse)({
                    type: 'doc',
                    content: includedContent
                }, createVisitors(includedContentMacroId, new Set()));
                const nestedContent = node?.attrs?.parameters?.nestedContent;
                if (nestedContent && typeof nestedContent === 'object') // Recursively traverse the nested content with the same visitors
                // This allows us to handle nested LCMs (LCMs within LCMs)
                (0, $jTt8P.traverse)(nestedContent, createVisitors(parentMacroId));
                return node;
            },
            bodiedExtension: (node)=>{
                if ($1091a8df710790c5$var$isIncludedContentNode(node)) {
                    const includedContentReference = $1091a8df710790c5$var$extractIncludedContentReferenceFromNode(node, defaultSpaceKey);
                    const includedContent = getIncludedContentForNode(node);
                    const includedContentMacroId = includedContentReference?.macroId || $1091a8df710790c5$var$getMacroId(node);
                    if (includedContent && includedContentMacroId) (0, $jTt8P.traverse)({
                        type: 'doc',
                        content: includedContent
                    }, createVisitors(includedContentMacroId, new Set()));
                }
                return node;
            }
        });
    // Traverse through ADF and filter out nodes that doesn't belong in the TOC
    // Options includes (minLevel, maxLevel, includeheaderregex, excludeheaderrregex)
    (0, $jTt8P.traverse)(adfObject || {}, createVisitors());
    if (cacheBucket && cacheKey) // Store a copy so subsequent mutations of the returned array don't pollute the cache.
    cacheBucket.set(cacheKey, headingElements.slice());
    return headingElements;
};












var $1OGI3 = parcelRequire("1OGI3");


var $ceVeI = parcelRequire("ceVeI");


var $dF6Hu = parcelRequire("dF6Hu");





var $bzfjI = parcelRequire("bzfjI");


var $6K7Y4 = parcelRequire("6K7Y4");


const $ada8f7f5b9a74558$var$logger = (0, $7W8i8.getLogger)('table-of-contents');
const $ada8f7f5b9a74558$var$parseAdfPayload = (payload)=>{
    if (!payload) return undefined;
    try {
        return JSON.parse(payload);
    } catch (error) {
        $ada8f7f5b9a74558$var$logger.error`Failed to parse included content payload for TOC - ${error}`;
        return undefined;
    }
};
/**
 * Subscribes to the same GraphQL query used by ExcerptIncludeImpl
 * (useExperimentalMacroMetadataQuery). Because that hook keys by JSON.stringify
 * of variables and uses an internal shared cache, we get the macro's result
 * without firing an extra request.
 */ const $ada8f7f5b9a74558$var$ExcerptIncludeTocSubscriber = (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { reference: reference, onResolve: onResolve } = t0;
    const t1 = reference.parentContentId ?? "";
    const t2 = reference.extensionType ?? "";
    let t3;
    if ($[0] !== reference.macroMetadata) {
        t3 = JSON.stringify(reference.macroMetadata ?? {});
        $[0] = reference.macroMetadata;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== reference.macroParams) {
        t4 = JSON.stringify(reference.macroParams ?? {});
        $[2] = reference.macroParams;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = {
            macroMetadata: t3,
            macroParams: t4
        };
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = reference.nodeType ?? "extension";
    let t7;
    if ($[7] !== t2 || $[8] !== t5 || $[9] !== t6) {
        t7 = {
            extensionKey: "excerpt-include",
            extensionType: t2,
            parameters: t5,
            type: t6
        };
        $[7] = t2;
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t1 || $[12] !== t7) {
        t8 = {
            contentId: t1,
            macroNode: t7
        };
        $[11] = t1;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    const variables = t8;
    const t9 = !reference.parentContentId;
    let t10;
    if ($[14] !== t9 || $[15] !== variables) {
        t10 = {
            variables: variables,
            skip: t9
        };
        $[14] = t9;
        $[15] = variables;
        $[16] = t10;
    } else t10 = $[16];
    const { data: data, loading: loading, error: error } = (0, $1OGI3.useExperimentalMacroMetadataQuery)(t10);
    let t11;
    if ($[17] !== data?.experimentalMacroMetadata?.payload || $[18] !== error || $[19] !== loading || $[20] !== onResolve || $[21] !== reference.excerptName || $[22] !== reference.key) {
        t11 = ()=>{
            if (loading) return;
            if (error) {
                onResolve({
                    key: reference.key,
                    content: []
                });
                return;
            }
            const parsed = $ada8f7f5b9a74558$var$parseAdfPayload(data?.experimentalMacroMetadata?.payload);
            if (!parsed) {
                onResolve({
                    key: reference.key,
                    content: []
                });
                return;
            }
            let content;
            if (Array.isArray(parsed)) content = parsed;
            else {
                if (parsed.type === "doc" && Array.isArray(parsed.content)) content = (0, $1091a8df710790c5$export$9f28523e22d9b3e2)(parsed, reference.excerptName);
                else if (Array.isArray(parsed.content)) content = parsed.content ?? [];
                else content = [];
            }
            onResolve({
                key: reference.key,
                content: content
            });
        };
        $[17] = data?.experimentalMacroMetadata?.payload;
        $[18] = error;
        $[19] = loading;
        $[20] = onResolve;
        $[21] = reference.excerptName;
        $[22] = reference.key;
        $[23] = t11;
    } else t11 = $[23];
    let t12;
    if ($[24] !== data || $[25] !== error || $[26] !== loading || $[27] !== onResolve || $[28] !== reference.excerptName || $[29] !== reference.key) {
        t12 = [
            data,
            loading,
            error,
            reference.key,
            reference.excerptName,
            onResolve
        ];
        $[24] = data;
        $[25] = error;
        $[26] = loading;
        $[27] = onResolve;
        $[28] = reference.excerptName;
        $[29] = reference.key;
        $[30] = t12;
    } else t12 = $[30];
    (0, $cozmU.useEffect)(t11, t12);
    return null;
};
/**
 * Include Page (extensionKey 'include'/'include-page') support is gated on the
 * macro migration being active for the current tenant. The legacy include
 * renderer does not expose the included page's ADF to the client, so TOC
 * headings can only be resolved for the migrated `PageIncludeImpl`.
 *
 * When the migration is enabled, `PageIncludeImpl` resolves the included page
 * via `usePageIncludeMacroQuery` (Apollo, `cache-first`). We subscribe to the
 * exact same query with the exact same target so Apollo serves the already
 * cached result — no additional network request is fired for the TOC.
 */ const $ada8f7f5b9a74558$var$IncludePageTocSubscriber = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { reference: reference, onResolve: onResolve } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $ceVeI.isMigratedMacroImplEnabled)("include");
        $[0] = t1;
    } else t1 = $[0];
    const isMigrated = t1;
    const t2 = isMigrated ? reference.macroParams : undefined;
    let t3;
    if ($[1] !== t2) {
        t3 = (0, $6K7Y4.parseMacroTarget)(t2);
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const parsedTarget = t3;
    const { adfString: adfString, loading: loading, error: error } = (0, $bzfjI.usePageIncludeMacroQuery)(parsedTarget, reference.hostSpaceKey);
    let t4;
    let t5;
    if ($[3] !== adfString || $[4] !== error || $[5] !== loading || $[6] !== onResolve || $[7] !== reference.key) {
        t4 = ()=>{
            if (!isMigrated) {
                onResolve({
                    key: reference.key,
                    content: []
                });
                return;
            }
            if (loading) return;
            if (error || !adfString) {
                onResolve({
                    key: reference.key,
                    content: []
                });
                return;
            }
            const parsedDocument = (0, $dF6Hu.parseNestedAdfDocument)(adfString);
            onResolve({
                key: reference.key,
                content: parsedDocument.content ?? []
            });
        };
        t5 = [
            isMigrated,
            adfString,
            loading,
            error,
            reference.key,
            onResolve
        ];
        $[3] = adfString;
        $[4] = error;
        $[5] = loading;
        $[6] = onResolve;
        $[7] = reference.key;
        $[8] = t4;
        $[9] = t5;
    } else {
        t4 = $[8];
        t5 = $[9];
    }
    (0, $cozmU.useEffect)(t4, t5);
    return null;
};
const $ada8f7f5b9a74558$export$46d17d7be50ab84c = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { references: references, onEntry: onEntry } = t0;
    let t1;
    if ($[0] !== onEntry || $[1] !== references) {
        let t2;
        if ($[3] !== onEntry) {
            t2 = (reference)=>{
                if (reference.extensionKey === "excerpt-include") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ada8f7f5b9a74558$var$ExcerptIncludeTocSubscriber, {
                    key: reference.key,
                    reference: reference,
                    onResolve: onEntry
                });
                if (reference.extensionKey === "include" || reference.extensionKey === "include-page") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ada8f7f5b9a74558$var$IncludePageTocSubscriber, {
                    key: reference.key,
                    reference: reference,
                    onResolve: onEntry
                });
                return null;
            };
            $[3] = onEntry;
            $[4] = t2;
        } else t2 = $[4];
        t1 = references.map(t2);
        $[0] = onEntry;
        $[1] = references;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};


const $4b4696838b5828ee$var$EMPTY_INCLUDED_CONTENT_MAP = new Map();
const $4b4696838b5828ee$export$1acefb8585ac9187 = (references, enabled = true)=>{
    // Dedup references by their stable cache key. Multiple include macros that
    // point at the same content get a single subscriber.
    // `refKeys` is a stable string derived from the reference keys, so the memo
    // below keeps a stable identity even when `references` is a fresh array on
    // each render with the same logical contents.
    const refKeys = (0, $cozmU.useMemo)(()=>references.map((r)=>r.key).sort().join('|'), [
        references
    ]);
    const uniqueReferences = (0, $cozmU.useMemo)(()=>{
        const byKey = new Map();
        for (const reference of references)byKey.set(reference.key, reference);
        return Array.from(byKey.values());
    // `references` is intentionally read inside the memo but excluded from the
    // deps; `refKeys` captures the only relevant change in its contents.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        refKeys
    ]);
    const [includedContentMap, setIncludedContentMap] = (0, $cozmU.useState)(()=>new Map());
    // Held as a ref so the onEntry callback identity is stable across renders.
    // Without this, every render would re-mount the subscribers and re-trigger
    // their effects.
    const mapRef = (0, $cozmU.useRef)(includedContentMap);
    mapRef.current = includedContentMap;
    const handleEntry = (0, $cozmU.useCallback)((entry)=>{
        const existing = mapRef.current.get(entry.key);
        if (existing && $4b4696838b5828ee$var$areArraysShallowEqual(existing, entry.content)) return;
        setIncludedContentMap((current)=>{
            const next = new Map(current);
            next.set(entry.key, entry.content);
            return next;
        });
    }, []);
    const subscribersElement = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ada8f7f5b9a74558$export$46d17d7be50ab84c), {
            references: uniqueReferences,
            onEntry: handleEntry
        }), [
        uniqueReferences,
        handleEntry
    ]);
    // When disabled, return inert values so the caller mounts no subscribers and
    // the TOC walker sees an empty map. Hooks above still run unconditionally to
    // keep hook order stable.
    if (!enabled) return {
        includedContentMap: $4b4696838b5828ee$var$EMPTY_INCLUDED_CONTENT_MAP,
        subscribersElement: undefined
    };
    return {
        includedContentMap: includedContentMap,
        subscribersElement: subscribersElement
    };
};
const $4b4696838b5828ee$var$areArraysShallowEqual = (a, b)=>{
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
};









var $79mJ9 = parcelRequire("79mJ9");




/**
 * Returns true when every entity is a plain text node with no marks (or a hardBreak)
 */ const $3c658fd5408d21d0$var$isPlainTextOnly = (entities)=>{
    for (const entity of entities){
        if (!entity) continue;
        if (entity.type === 'hardBreak') continue;
        if (entity.type === 'text' && (!entity.marks || entity.marks.length === 0)) continue;
        return false;
    }
    return true;
};
function $3c658fd5408d21d0$export$9610d4f5b4c2681a(elementsArray, parentOutline = [], cloudId, userId) {
    if (elementsArray.length === 0) return null;
    const highestElementPrecedence = elementsArray.map((el)=>el?.attrs?.level).reduce(function(a, b) {
        return Math.min(a, b);
    });
    // Make sure the first element in the list matches the highest precedence level
    if (elementsArray[0]?.attrs?.level !== highestElementPrecedence) elementsArray.unshift({
        type: 'toc',
        attrs: {
            level: highestElementPrecedence
        },
        content: [
            {
                text: (0, $8Utl8.EmptyTocItem),
                type: 'string',
                innerHTML: ''
            }
        ]
    });
    const currentList = [];
    const subListBuffer = {
        subElements: [],
        currentItem: {
            innerContent: null,
            link: '',
            outline: [],
            children: null
        },
        outline: undefined,
        flush () {
            // eslint-disable-next-line react/prefer-stateless-function
            if (subListBuffer.subElements.length > 0 && subListBuffer.currentItem) {
                subListBuffer.currentItem.children = $3c658fd5408d21d0$export$9610d4f5b4c2681a(subListBuffer.subElements, subListBuffer.outline, cloudId, userId);
                subListBuffer.subElements = [];
            }
        },
        add (element) {
            subListBuffer.subElements.push(element);
        },
        resetItem (currentOutlineItem) {
            subListBuffer.outline = (parentOutline || []).slice(0);
            subListBuffer.outline.push(currentOutlineItem);
            subListBuffer.currentItem = {
                innerContent: null,
                link: '',
                outline: [],
                children: null
            };
            currentList.push(subListBuffer.currentItem);
            return subListBuffer.currentItem;
        }
    };
    let outlineCounter = 0;
    elementsArray.forEach(function(element) {
        if (element?.attrs?.level === highestElementPrecedence) {
            outlineCounter++;
            subListBuffer.flush();
            subListBuffer.resetItem(outlineCounter);
            if (element.content?.[0]?.text !== (0, $8Utl8.EmptyTocItem) && subListBuffer.currentItem) {
                const style = $3c658fd5408d21d0$var$createSSRTocItemBody(element, cloudId, userId, subListBuffer.outline?.join('.'));
                subListBuffer.currentItem.innerContent = style.linkText;
                subListBuffer.currentItem.link = style.linkHref;
                subListBuffer.currentItem.outline = style.outline ? [
                    style.outline
                ] : [];
            } else {
                subListBuffer.currentItem.innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
                subListBuffer.currentItem.link = (0, $8Utl8.EmptyTocItem);
            }
        } else subListBuffer.add(element);
    });
    subListBuffer.flush();
    return currentList;
}
/**
 *
 * @param obj
 * @param outline
 * Creates an HTML element representing a single item in the TOC, including outline level and a link.
 */ function $3c658fd5408d21d0$var$createSSRTocItemBody(obj, cloudId, userId, outline) {
    return {
        outline: outline,
        linkHref: `#${encodeURIComponent(obj?.attrs?.id)}`,
        linkText: $3c658fd5408d21d0$var$getTextsFromElements(obj.content || [], cloudId, userId)
    };
}
/*
 ** Accumulates the texts from elements into a single header
 */ function $3c658fd5408d21d0$var$getTextsFromElements(contentArray, cloudId, userId) {
    if (!contentArray) return null;
    // When every node is plain text / hardBreak with no marks we can render the
    // concatenated string directly and skip the heavy MiniRenderer pipeline.
    if ((0, $6mKj3.expVal)('confluence_toc_render_perf', 'isEnabled', false)) {
        if ($3c658fd5408d21d0$var$isPlainTextOnly(contentArray)) {
            let out = '';
            for (const entity of contentArray){
                if (!entity || entity.type === 'hardBreak') continue;
                if (entity.text) out += entity.text;
            }
            return out;
        }
    }
    // Usage for mini-renderer
    // This is necessary as TOC runs into a race condition if we simply inject rendered results from the DOM
    // Because of async components that contain headers, ADF may not have sufficient content to render everything
    // We need to decide whether or not it is necessary to render injected output thereafter
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79mJ9.MiniRenderer), {
        adfEntities: contentArray,
        cloudId: cloudId,
        userId: userId
    });
}












var $kSwu1 = parcelRequire("kSwu1");


var $9wGTI = parcelRequire("9wGTI");








function $8abacf7de2a86dda$var$getInitialSeparator(ref) {
    if (ref.current === true) {
        ref.current = false;
        return true;
    } else return false;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8abacf7de2a86dda$var$EmptyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $8abacf7de2a86dda$var$i18n = (0, $kSwu1.defineMessages)({
    emptyToc: {
        id: "table-of-contents.empty-toc",
        defaultMessage: "Add headings to this page and they\u2019ll instantly appear here."
    },
    livePageEmptyToc: {
        id: "table-of-contents.live-page-empty-toc",
        defaultMessage: "Add headings to this doc and they\u2019ll instantly appear here."
    }
});
const $8abacf7de2a86dda$export$1199a72d11f104e4 = (t0)=>{
    const $ = (0, $bDgLe.c)(47);
    const { elementsArray: elementsArray, elementFactory: elementFactory, config: config, separators: separators, initialSeparatorRef: initialSeparatorRef, isInEditMode: isInEditMode, shouldExpandParentExpandsOnScroll: shouldExpandParentExpandsOnScroll } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (!elementsArray) {
        if (isInEditMode) {
            let t1;
            if ($[0] !== intl || $[1] !== isLivePage) {
                let t2;
                if ($[3] !== isLivePage) {
                    t2 = isLivePage && (0, $9wGTI.fg)("confluence_live_pages_open_beta_trait_opted_in") ? $8abacf7de2a86dda$var$i18n.livePageEmptyToc : $8abacf7de2a86dda$var$i18n.emptyToc;
                    $[3] = isLivePage;
                    $[4] = t2;
                } else t2 = $[4];
                t1 = intl.formatMessage(t2);
                $[0] = intl;
                $[1] = isLivePage;
                $[2] = t1;
            } else t1 = $[2];
            let t2;
            if ($[5] !== t1) {
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8abacf7de2a86dda$var$EmptyContainer, null, t1);
                $[5] = t1;
                $[6] = t2;
            } else t2 = $[6];
            return t2;
        } else {
            let t1;
            if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null);
                $[7] = t1;
            } else t1 = $[7];
            return t1;
        }
    }
    let t1;
    if ($[8] !== elementFactory) {
        t1 = elementFactory.createTocLevelContainer();
        $[8] = elementFactory;
        $[9] = t1;
    } else t1 = $[9];
    const ElementsContainer = t1;
    let t2;
    if ($[10] !== elementFactory) {
        t2 = elementFactory.createTocItemContainer();
        $[10] = elementFactory;
        $[11] = t2;
    } else t2 = $[11];
    const ItemContainer = t2;
    if (config.structure === "flat") {
        let T0;
        let t3;
        let t4;
        if ($[12] !== ElementsContainer || $[13] !== config || $[14] !== elementsArray || $[15] !== initialSeparatorRef || $[16] !== separators?.[0] || $[17] !== separators?.[1] || $[18] !== separators?.[2] || $[19] !== shouldExpandParentExpandsOnScroll) {
            function buildFlatSubtree(subArray) {
                return subArray.map((element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                        key: element.outline
                    }, element.link !== (0, $8Utl8.EmptyTocItem) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                        className: "toc-separator"
                    }, $8abacf7de2a86dda$var$getInitialSeparator(initialSeparatorRef) ? separators?.[0] : separators?.[1]), $8abacf7de2a86dda$var$createTocItemBodyComponent(element, config.outline, shouldExpandParentExpandsOnScroll)) : null, element.children ? buildFlatSubtree(element.children) : null));
            }
            T0 = ElementsContainer;
            t3 = config;
            t4 = elementsArray.map((element_0, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                    key: idx
                }, element_0.link !== (0, $8Utl8.EmptyTocItem) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    className: "toc-separator"
                }, $8abacf7de2a86dda$var$getInitialSeparator(initialSeparatorRef) ? separators?.[0] : separators?.[1]), $8abacf7de2a86dda$var$createTocItemBodyComponent(element_0, config.outline, shouldExpandParentExpandsOnScroll)) : null, element_0.children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, buildFlatSubtree(element_0.children)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    className: "toc-separator"
                }, idx === elementsArray.length - 1 ? separators?.[2] : null)));
            $[12] = ElementsContainer;
            $[13] = config;
            $[14] = elementsArray;
            $[15] = initialSeparatorRef;
            $[16] = separators?.[0];
            $[17] = separators?.[1];
            $[18] = separators?.[2];
            $[19] = shouldExpandParentExpandsOnScroll;
            $[20] = T0;
            $[21] = t3;
            $[22] = t4;
        } else {
            T0 = $[20];
            t3 = $[21];
            t4 = $[22];
        }
        let t5;
        if ($[23] !== T0 || $[24] !== t3 || $[25] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
                prop: t3
            }, t4);
            $[23] = T0;
            $[24] = t3;
            $[25] = t4;
            $[26] = t5;
        } else t5 = $[26];
        return t5;
    }
    if (elementsArray) {
        let t3;
        if ($[27] !== ItemContainer || $[28] !== config || $[29] !== elementFactory || $[30] !== elementsArray || $[31] !== initialSeparatorRef || $[32] !== separators || $[33] !== shouldExpandParentExpandsOnScroll) {
            let t4;
            if ($[35] !== ItemContainer || $[36] !== config || $[37] !== elementFactory || $[38] !== initialSeparatorRef || $[39] !== separators || $[40] !== shouldExpandParentExpandsOnScroll) {
                t4 = (element_1)=>{
                    if (element_1.innerContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, element_1.link !== (0, $8Utl8.EmptyTocItem) || element_1?.children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemContainer, {
                        link: element_1.link,
                        prop: config,
                        key: element_1?.outline
                    }, element_1.link !== (0, $8Utl8.EmptyTocItem) ? $8abacf7de2a86dda$var$createTocItemBodyComponent(element_1, config.outline, shouldExpandParentExpandsOnScroll) : null, element_1.children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8abacf7de2a86dda$export$1199a72d11f104e4, {
                        elementsArray: element_1.children,
                        elementFactory: elementFactory,
                        config: config,
                        separators: separators,
                        initialSeparatorRef: initialSeparatorRef,
                        isInEditMode: false,
                        shouldExpandParentExpandsOnScroll: shouldExpandParentExpandsOnScroll
                    }) : null) : null);
                    else return null;
                };
                $[35] = ItemContainer;
                $[36] = config;
                $[37] = elementFactory;
                $[38] = initialSeparatorRef;
                $[39] = separators;
                $[40] = shouldExpandParentExpandsOnScroll;
                $[41] = t4;
            } else t4 = $[41];
            t3 = elementsArray.map(t4);
            $[27] = ItemContainer;
            $[28] = config;
            $[29] = elementFactory;
            $[30] = elementsArray;
            $[31] = initialSeparatorRef;
            $[32] = separators;
            $[33] = shouldExpandParentExpandsOnScroll;
            $[34] = t3;
        } else t3 = $[34];
        let t4;
        if ($[42] !== ElementsContainer || $[43] !== config || $[44] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ElementsContainer, {
                prop: config
            }, t3);
            $[42] = ElementsContainer;
            $[43] = config;
            $[44] = t3;
            $[45] = t4;
        } else t4 = $[45];
        return t4;
    }
    let t3;
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "Empty-TOC"
        });
        $[46] = t3;
    } else t3 = $[46];
    return t3;
};
/**
 *
 * @param element
 * @param displayOutline
 *
 * Build the Inner item body for TOC
 *
 */ function $8abacf7de2a86dda$var$createTocItemBodyComponent(element, displayOutline, shouldExpandParentExpandsOnScroll) {
    return (0, $bae8eba0391a5294$export$d9f23a508df4a861)(element, displayOutline, shouldExpandParentExpandsOnScroll);
}












var $iNIw3 = parcelRequire("iNIw3");







const $8e0e4b45677b9150$var$logger = (0, $7W8i8.getLogger)('table-of-contents:useCurrentAdf');
/**
 * Parse a stringified ADF into an object form, returning the same reference for
 * the same input string identity so downstream consumers can rely on object identity for memoization.
 */ const $8e0e4b45677b9150$var$useStableParsedAdf = (adf)=>(0, $cozmU.useMemo)(()=>{
        if (typeof adf !== 'string') return adf;
        try {
            return JSON.parse(adf);
        } catch (err) {
            $8e0e4b45677b9150$var$logger.error`Failed to parse ADF string in useCurrentAdf: ${err}`;
            return adf;
        }
    }, [
        adf
    ]);
/**
 * Cheap structural check: returns true if the ADF contains any extension-style
 * node (`extension`, `bodiedExtension`, `inlineExtension`)
 */ const $8e0e4b45677b9150$var$hasAnyExtensionNode = (adf)=>{
    if (!adf) return false;
    let adfObject = adf;
    if (typeof adf === 'string') try {
        adfObject = JSON.parse(adf);
    } catch  {
        return false;
    }
    let found = false;
    const markFound = (node)=>{
        found = true;
        return node;
    };
    (0, $jTt8P.traverse)(adfObject || {}, {
        extension: markFound,
        bodiedExtension: markFound,
        inlineExtension: markFound
    });
    return found;
};
const $8e0e4b45677b9150$export$595f30d6a02162ab = (adf, isInEditMode)=>{
    const $ = (0, $bDgLe.c)(6);
    const parsedAdf = $8e0e4b45677b9150$var$useStableParsedAdf(adf);
    const [currentAdf, setCurrentAdf] = (0, $cozmU.useState)(parsedAdf);
    let t0;
    bb0: {
        if (!(0, $6mKj3.expVal)("confluence_toc_render_perf", "isEnabled", false)) {
            t0 = true;
            break bb0;
        }
        let t1;
        if ($[0] !== parsedAdf) {
            t1 = $8e0e4b45677b9150$var$hasAnyExtensionNode(parsedAdf);
            $[0] = parsedAdf;
            $[1] = t1;
        } else t1 = $[1];
        t0 = t1;
    }
    const shouldListenForForgeUpdates = t0;
    let t1;
    let t2;
    if ($[2] !== isInEditMode || $[3] !== shouldListenForForgeUpdates) {
        t1 = ()=>{
            if (!isInEditMode && shouldListenForForgeUpdates) {
                const onForgeDocUpdated = (event)=>$8e0e4b45677b9150$export$5aa9e1e60a480751(event, setCurrentAdf);
                document.addEventListener((0, $iNIw3.FORGE_DOC_UPDATED_EVENT), onForgeDocUpdated);
                return ()=>document.removeEventListener((0, $iNIw3.FORGE_DOC_UPDATED_EVENT), onForgeDocUpdated);
            }
        };
        t2 = [
            isInEditMode,
            shouldListenForForgeUpdates
        ];
        $[2] = isInEditMode;
        $[3] = shouldListenForForgeUpdates;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isInEditMode ? parsedAdf : currentAdf;
};
const $8e0e4b45677b9150$export$5aa9e1e60a480751 = (event, setAdf)=>{
    const { forgeDoc: forgeDoc, localId: localId } = event.detail;
    setAdf((prevAdf)=>{
        let adfObject = prevAdf;
        if (typeof prevAdf === 'string') try {
            adfObject = JSON.parse(prevAdf);
        } catch (_err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            return prevAdf;
        }
        const newAdf = (0, $jTt8P.traverse)(adfObject, {
            // Match the triggering macro's localId in the ADF and update the macro content
            bodiedExtension: (node)=>{
                if (node.attrs?.localId === localId) {
                    const newContent = forgeDoc?.children?.[0]?.props?.document?.content;
                    if (newContent) node.content = newContent;
                    return node;
                }
            }
        });
        if (newAdf) return newAdf;
        return prevAdf;
    });
};


const $3c9bbcd4bd01fb6c$export$cd8f8ae5a1332c1a = 'non-printable-wrapper'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c9bbcd4bd01fb6c$var$NonPrintableWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _1Qs34tdnbC _36Gbs7dnbC _08KCXeYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $3c9bbcd4bd01fb6c$export$387c7b71086d6280 = 'printable-wrapper'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c9bbcd4bd01fb6c$var$PrintableWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAIZbP _2WAcuGIZbP _1Qs34tdnbC _36Gbs7dnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $3c9bbcd4bd01fb6c$export$eccbcf752b159ac1(separator) {
    switch(separator.toLowerCase()){
        case 'braces':
            return [
                '{ ',
                ' } { ',
                ' }'
            ];
        case 'pipe':
            return [
                '',
                ' | ',
                ''
            ];
        case 'parens':
            return [
                '( ',
                ' ) ( ',
                ' )'
            ];
        case '':
        case 'brackets':
            // brackets in the ADF is an empty string
            return [
                '[ ',
                ' ] [ ',
                ' ]'
            ];
        default:
            // Match separator usage for custom separators
            return [
                '',
                separator,
                ''
            ];
    }
}
/**
 * Builder for the `attributes` payload sent on the TOC `viewMacroExperience` success event.
 * The `confluence-feature-gating/inline-usage` lint rule forbids `expVal(...)` as a property value inside a JSX-bound `ObjectExpression`
 */ const $3c9bbcd4bd01fb6c$var$buildTocSuccessAttributes = (perfOptimizationsEnabled, handleTocDurationMs, treeBuildDurationMs, reducedDomDurationMs, headingCount, structure, usedReducedDomPath)=>({
        tocHandleAdfDurationMs: handleTocDurationMs === null ? null : Math.round(handleTocDurationMs),
        tocTreeBuildDurationMs: treeBuildDurationMs === null ? null : Math.round(treeBuildDurationMs),
        tocReducedDomDurationMs: reducedDomDurationMs === null ? null : Math.round(reducedDomDurationMs),
        tocHeadingCount: headingCount,
        tocStructure: structure,
        tocUsedReducedDomPath: usedReducedDomPath,
        tocPerfOptimizationsEnabled: perfOptimizationsEnabled
    });
const $3c9bbcd4bd01fb6c$var$TableOfContentsContainer = ({ cloudId: cloudId, userId: userId, adf: adf, macroDefaultProps: macroDefaultProps, isInEditMode: isInEditMode = false })=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { node: node, mode: mode, contentId: contentId, extensionKey: extensionKey, spaceKey: spaceKey } = macroDefaultProps;
    const isClassicPublishedEditorRendererPage = mode === (0, $5kjCz.RENDERER) && !isInEditMode && !isLivePage;
    const currentAdf = (0, $8e0e4b45677b9150$export$595f30d6a02162ab)(adf, isInEditMode);
    const macroNode = (0, $cozmU.useMemo)(()=>(0, $6mEZ3.extensionToADF)(node), [
        node
    ]); // The `confluence_toc_included_content_exp` experiment gates every
    // included-content code path (references, live map, and the heading walker).
    // The check is inlined at each callsite per the
    // confluence-feature-gating/inline-usage rule; its value is stable within a
    // session, so it is intentionally omitted from dep arrays.
    const includedContentReferences = (0, $cozmU.useMemo)(()=>(0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true) ? (0, $1091a8df710790c5$export$8235d87af2537ef3)(currentAdf, spaceKey, contentId) : [], [
        currentAdf,
        spaceKey,
        contentId
    ]);
    const { includedContentMap: includedContentMap, subscribersElement: subscribersElement } = (0, $4b4696838b5828ee$export$1acefb8585ac9187)(includedContentReferences, (0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true)); // Phase-timing for the perf-optimization A/B. We measure inside each `useMemo`
    // so the duration only reflects real work (not cache hits).
    const handleTocDurationRef = (0, $cozmU.useRef)(null);
    const treeBuildDurationRef = (0, $cozmU.useRef)(null);
    const reducedDomDurationRef = (0, $cozmU.useRef)(null);
    handleTocDurationRef.current = null;
    const tocOptions = (0, $cozmU.useMemo)(()=>{
        const start = performance.now();
        try {
            return (0, $1091a8df710790c5$export$bebd062f3d239910)(macroNode, currentAdf, includedContentMap, spaceKey, (0, $6mKj3.expValEquals)('confluence_toc_included_content_exp', 'isEnabled', true));
        } finally{
            handleTocDurationRef.current = performance.now() - start;
        }
    }, [
        macroNode,
        currentAdf,
        includedContentMap,
        spaceKey
    ]);
    const name = (0, $5kjCz.getExperienceName)(mode, node);
    const ElementFactory = (0, $cozmU.useMemo)(()=>tocOptions.structure === 'flat' ? $3c9bbcd4bd01fb6c$var$flatTocElementFactory() : $3c9bbcd4bd01fb6c$var$listTocElementFactory(), [
        tocOptions.structure
    ]);
    const separators = (0, $cozmU.useMemo)(()=>$3c9bbcd4bd01fb6c$export$eccbcf752b159ac1(tocOptions.separators || ''), [
        tocOptions.separators
    ]);
    const initialSeparatorRef = {
        current: true
    };
    const [preseparator, midseparator, postseparator] = separators;
    const flatSeparators = (0, $cozmU.useMemo)(()=>tocOptions.structure === 'flat' ? {
            'data-preseparator': preseparator,
            'data-midseparator': midseparator,
            'data-postseparator': postseparator
        } : {}, [
        tocOptions.structure,
        preseparator,
        midseparator,
        postseparator
    ]);
    treeBuildDurationRef.current = null;
    const { elementsArray: elementsArray, error: error_0 } = (0, $cozmU.useMemo)(()=>{
        const start_0 = performance.now();
        try {
            return {
                elementsArray: (0, $3c658fd5408d21d0$export$9610d4f5b4c2681a)(tocOptions.headerelements, [], cloudId, userId),
                error: null
            };
        } catch (error) {
            return {
                elementsArray: null,
                error: error
            };
        } finally{
            treeBuildDurationRef.current = performance.now() - start_0;
        }
    }, [
        tocOptions?.headerelements,
        cloudId,
        userId
    ]); // Memoize the stringified macro params used as a DOM data attribute so we
    // don't pay the JSON.stringify cost on every render
    const macroParamsAttr = (0, $cozmU.useMemo)(()=>JSON.stringify(macroNode?.attrs?.parameters?.macroParams), [
        macroNode?.attrs?.parameters?.macroParams
    ]);
    reducedDomDurationRef.current = null;
    const reducedDomContent = (0, $cozmU.useMemo)(()=>{
        if (!(0, $6mKj3.expVal)('confluence_toc_reduce_dom_nodes', 'isEnabled', false)) return null;
        const start_1 = performance.now();
        try {
            return (0, $8Utl8.renderReducedToc)(tocOptions, separators, cloudId, userId, isClassicPublishedEditorRendererPage);
        } finally{
            reducedDomDurationRef.current = performance.now() - start_1;
        }
    }, [
        tocOptions,
        separators,
        cloudId,
        userId,
        isClassicPublishedEditorRendererPage
    ]);
    if (error_0) {
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JbVPK.MacroExperienceFailure), {
            name: name,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            error: error_0 || new Error(`${extensionKey} failed to render`),
            attributes: attributes,
            source: "TableOfContents"
        });
    } // Wrap tocContent for printable:
    let Wrapper;
    let wrapperTestId;
    let wrapperVc;
    if (tocOptions.printable === 'false') {
        Wrapper = $3c9bbcd4bd01fb6c$var$NonPrintableWrapper;
        wrapperTestId = $3c9bbcd4bd01fb6c$export$cd8f8ae5a1332c1a;
        wrapperVc = 'non-printable-toc-wrapper';
    } else {
        Wrapper = $3c9bbcd4bd01fb6c$var$PrintableWrapper;
        wrapperTestId = $3c9bbcd4bd01fb6c$export$387c7b71086d6280;
        wrapperVc = 'printable-toc-wrapper';
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        title: "Macro (toc)",
        "data-fabric-macro": tocOptions.macroId,
        "data-macro-body": true,
        "data-macro-parameters": macroParamsAttr,
        "data-testid": wrapperTestId,
        "data-vc": wrapperVc,
        ...renderServerPlaceholder ? {
            'data-ssr-placeholder': tocOptions.macroId
        } : {
            'data-ssr-placeholder-replace': tocOptions.macroId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: tocOptions.className,
        "data-numberedoutline": tocOptions.outline,
        "data-cssliststyle": tocOptions.cssliststyle,
        "data-csslistindent": tocOptions.csslistindent,
        "data-headerelements": tocOptions.headerRange,
        "data-hasbody": tocOptions.hasbody,
        "data-macro-name": tocOptions.name,
        "data-macro-id": tocOptions.macroId,
        "data-structure": tocOptions.structure,
        "data-vc": "toc",
        ...flatSeparators,
        ...renderServerPlaceholder ? {
            'data-ssr-placeholder': `toc-${tocOptions.macroId}`
        } : {
            'data-ssr-placeholder-replace': `toc-${tocOptions.macroId}`
        }
    }, reducedDomContent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8abacf7de2a86dda$export$1199a72d11f104e4), {
        elementsArray: elementsArray,
        elementFactory: ElementFactory,
        config: tocOptions,
        separators: separators,
        initialSeparatorRef: initialSeparatorRef,
        isInEditMode: isInEditMode,
        shouldExpandParentExpandsOnScroll: isClassicPublishedEditorRendererPage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: name,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: $3c9bbcd4bd01fb6c$var$buildTocSuccessAttributes((0, $6mKj3.expVal)('confluence_toc_render_perf', 'isEnabled', false), handleTocDurationRef.current, treeBuildDurationRef.current, reducedDomDurationRef.current, Array.isArray(tocOptions?.headerelements) ? tocOptions.headerelements.length : 0, tocOptions?.structure ?? 'unknown', reducedDomContent !== null)
    })), subscribersElement && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        hidden: true,
        "aria-hidden": "true",
        "data-testid": "toc-included-content-subscribers"
    }, subscribersElement));
};
/**
 * Creates HTML elements for use in building a flat-style TOC
 */ function $3c9bbcd4bd01fb6c$var$flatTocElementFactory() {
    return {
        createTocLevelContainer () {
            return 0, $bae8eba0391a5294$export$127d6feb1b4cbb5f;
        },
        createTocItemContainer () {
            return 0, $bae8eba0391a5294$export$127d6feb1b4cbb5f;
        },
        decorateToc () {
            return true;
        }
    };
} /**
   * Creates HTML elements for use in building a list-style TOC
   */ 
function $3c9bbcd4bd01fb6c$var$listTocElementFactory() {
    return {
        createTocLevelContainer () {
            return 0, $bae8eba0391a5294$export$cac47b1ba5f92468;
        },
        createTocItemContainer () {
            return 0, $bae8eba0391a5294$export$9b4f02b15f3133b5;
        }
    };
}
const $3c9bbcd4bd01fb6c$var$TableOfContentsWithBoundary = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($3c9bbcd4bd01fb6c$var$TableOfContentsContainer); // Single `memo()` with a custom comparator that branches on the experiment value at compare-time.
const $3c9bbcd4bd01fb6c$var$propsAreEqual = (prev, next)=>{
    if ((0, $6mKj3.expVal)('confluence_toc_render_perf', 'isEnabled', false)) {
        // Default shallow compare — same semantics as `memo(component)` with no comparator.
        const prevKeys = Object.keys(prev);
        const nextKeys = Object.keys(next);
        if (prevKeys.length !== nextKeys.length) return false;
        for (const key of prevKeys){
            if (prev[key] !== next[key]) return false;
        }
        return true;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prev, next);
};
const $3c9bbcd4bd01fb6c$export$65a20d5539dff777 = /*#__PURE__*/ (0, $cozmU.memo)($3c9bbcd4bd01fb6c$var$TableOfContentsWithBoundary, $3c9bbcd4bd01fb6c$var$propsAreEqual);
module.exports["nonPrintableWrapperTestId"] = $3c9bbcd4bd01fb6c$export$cd8f8ae5a1332c1a;
module.exports["printableWrapperTestId"] = $3c9bbcd4bd01fb6c$export$387c7b71086d6280;
module.exports["getSeparators"] = $3c9bbcd4bd01fb6c$export$eccbcf752b159ac1;
module.exports["TableOfContents"] = $3c9bbcd4bd01fb6c$export$65a20d5539dff777;

});

parcelRegister("JbVPK", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $98aa426b73cdcfeb$export$e394c7ce8301e00f({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, error: error, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
            name: name,
            attributes: {
                ...attributes,
                source: source
            },
            error: error
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        error,
        mode,
        name,
        source
    ]);
    return children;
}
module.exports["MacroExperienceFailure"] = $98aa426b73cdcfeb$export$e394c7ce8301e00f;

});

parcelRegister("4WITQ", function(module, exports) {

let $399f685abde0afcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $399f685abde0afcb$var$load("3ioZJ").then(()=>parcelRequire('5vSwz'));

});

parcelRegister("8KLwI", function(module, exports) {

let $65f77c65c72bb2eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $65f77c65c72bb2eb$var$load("g81ly"),
    $65f77c65c72bb2eb$var$load("e3LAK"),
    $65f77c65c72bb2eb$var$load("ajDCL"),
    $65f77c65c72bb2eb$var$load("iTmpz")
]).then(()=>parcelRequire('l5vdF'));

});

parcelRegister("2GLbB", function(module, exports) {

let $1f541b380bb474c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f541b380bb474c3$var$load("8OJBc").then(()=>parcelRequire('hqnQO'));

});

parcelRegister("94CVU", function(module, exports) {

let $69b2b0132f19b98b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $69b2b0132f19b98b$var$load("4KIrO"),
    $69b2b0132f19b98b$var$load("hhss7"),
    $69b2b0132f19b98b$var$load("Wowvf"),
    $69b2b0132f19b98b$var$load("fDwDZ")
]).then(()=>parcelRequire('2I7c2'));

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("202oG", function(module, exports) {

var $2lPWP = parcelRequire("2lPWP");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $2lPWP.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("1OGI3", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dK51B = parcelRequire("dK51B");


var $iTHnt = parcelRequire("iTHnt");


var $f7B1p = parcelRequire("f7B1p");

const $49cc3e2647f46bd6$export$f10f4b8a29d2407e = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { variables: variables, skip: t1, fetchPolicy: t2 } = t0;
    const skip = t1 === undefined ? false : t1;
    const fetchPolicy = t2 === undefined ? "cache-first" : t2;
    let t3;
    if ($[0] !== variables) {
        t3 = async ()=>{
            const result = await (0, $iTHnt.experimentalMacroMetadata)({}, variables, {
                network: {
                    cfetch: $f7B1p.cfetch
                }
            });
            return {
                experimentalMacroMetadata: result ? {
                    payload: result.payload ?? null,
                    contentId: result.contentId ?? null
                } : null
            };
        };
        $[0] = variables;
        $[1] = t3;
    } else t3 = $[1];
    const fetchData = t3;
    let t4;
    if ($[2] !== variables) {
        t4 = JSON.stringify({
            query: "experimentalMacroMetadata",
            variables: variables
        });
        $[2] = variables;
        $[3] = t4;
    } else t4 = $[3];
    const key = t4;
    let t5;
    if ($[4] !== fetchData || $[5] !== fetchPolicy || $[6] !== key || $[7] !== skip || $[8] !== variables) {
        t5 = {
            key: key,
            fetchData: fetchData,
            variables: variables,
            skip: skip,
            fetchPolicy: fetchPolicy
        };
        $[4] = fetchData;
        $[5] = fetchPolicy;
        $[6] = key;
        $[7] = skip;
        $[8] = variables;
        $[9] = t5;
    } else t5 = $[9];
    return (0, $dK51B.useExperimentalQueryBase)(t5);
};
module.exports["useExperimentalMacroMetadataQuery"] = $49cc3e2647f46bd6$export$f10f4b8a29d2407e;

});

parcelRegister("iTHnt", function(module, exports) {

var $1arfH = parcelRequire("1arfH");


var $aBfpe = parcelRequire("aBfpe");


var $9wGTI = parcelRequire("9wGTI");

const $742bec8a860b95f0$var$queryGraphQL = (network, { query: query, variables: variables })=>(0, $1arfH.fetchJSON)(network, '/cgraphql', {
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            variables: variables,
            query: query
        })
    });
/**
 * Recursively parses an ADF and returns all nodes that match a given extension
 * key.
 *
 * @param extensionKey The extension key to search for (e.g. 'excerpt-include')
 * @param currentNode The ADF node to recursively search through
 */ const $742bec8a860b95f0$var$parseForTargetMacroNodeByExtensionKey = (extensionKey, currentNode)=>{
    const matchedNodes = [];
    if (currentNode?.attrs?.extensionKey === extensionKey) matchedNodes.push(currentNode);
    // Search in direct content children
    if (currentNode.content) for (const childNode of currentNode.content)matchedNodes.push(...$742bec8a860b95f0$var$parseForTargetMacroNodeByExtensionKey(extensionKey, childNode));
    // Also search inside Legacy Content Macro (LCM) nestedContent parameter
    if (currentNode?.attrs?.extensionKey === 'legacy-content' && currentNode?.attrs?.extensionType === 'com.atlassian.confluence.migration' && currentNode?.attrs?.parameters?.nestedContent && (0, $9wGTI.fg)('confluence_excerpt_include_search_for_lcm')) matchedNodes.push(...$742bec8a860b95f0$var$parseForTargetMacroNodeByExtensionKey(extensionKey, currentNode.attrs.parameters.nestedContent));
    return matchedNodes;
};
/**
 * Queries cc-graphql for content with a given title, space, and type.
 *
 * @param cfetch cfetch
 * @param contentTitle The title of the content to query by (needs space key)
 * @param spaceKey The space key of the content
 * @param type Either "page" or "blogpost"
 */ const $742bec8a860b95f0$var$queryContent = (network, contentTitle, spaceKey, type)=>$742bec8a860b95f0$var$queryGraphQL(network, {
        query: `
      query excerptIncludeTargetPageQuery(
        $contentTitle: String!
        $spaceKey: String!
        $type: String!
      ) {
        content(title: $contentTitle, spaceKey: $spaceKey, type: $type) {
          nodes {
            id
            body {
              atlas_doc_format {
                value
              }
            }
          }
        }
      }
    `,
        variables: {
            contentTitle: contentTitle,
            spaceKey: spaceKey,
            type: type
        }
    });
const $742bec8a860b95f0$var$queryContentById = (network, contentId)=>$742bec8a860b95f0$var$queryGraphQL(network, {
        query: `
      query excerptIncludeTargetPageQueryById(
        $contentId: ID!
      ) {
        content(id: $contentId) {
          nodes {
            id
            body {
              atlas_doc_format {
                value
              }
            }
          }
        }
      }
    `,
        variables: {
            contentId: contentId
        }
    });
const $742bec8a860b95f0$var$getSpaceKey = (network, contentId)=>$742bec8a860b95f0$var$queryGraphQL(network, {
        query: `
      query consumerSpaceQuery($contentId: ID!) {
        content(id: $contentId, status: ["current", "draft"]) {
          nodes {
            id
            space {
              key
            }
          }
        }
      }
    `,
        variables: {
            contentId: contentId
        }
    });
/**
 * Guesses at whether the given title is from a blog or not (unreliable as
 * shiiiiiiiit).
 *
 * TODO: Remove dis.
 *
 * @param contentTitle The title of the content
 */ const $742bec8a860b95f0$var$isPossiblyBlogpost = (contentTitle)=>contentTitle.match(/^\/\d{4}\/\d{2}\/\d{2}\//) !== null;
/**
 * Guesses at whether the given title is from an external space or not.
 *
 * TODO: Remove this.
 *
 * @param contentInfo The title of the content
 */ const $742bec8a860b95f0$var$isPossiblyExternalContent = (contentInfo)=>contentInfo.indexOf(':') !== -1;
// Length of the date prefix that is in the data returned by the macro
const $742bec8a860b95f0$var$blogPrefixLength = 12;
/**
 * Removes the blog title prefix from the given content info.
 *
 * @param contentInfo The content info containing a blog title w/ prefix
 */ const $742bec8a860b95f0$var$getBlogpostTitle = (contentInfo)=>contentInfo.slice($742bec8a860b95f0$var$blogPrefixLength);
/**
 * For a content title that's prefixed with the space key, this strips the
 * space key out assuming that it matches the pattern `${SPACE_KEY}:${TITILE}`.
 *
 * @param contentInfo A content title assumedly prefixed with space key + ":"
 */ const $742bec8a860b95f0$var$getExternalContentTitle = (contentInfo)=>contentInfo.slice(contentInfo.indexOf(':') + 1);
/**
 * For a content title that's prefixed with the space key, this strips the
 * title out assuming that it matches the pattern `${SPACE_KEY}:${TITILE}`.
 *
 * @param contentInfo A content title assumedly prefixed with space key + ":"
 */ const $742bec8a860b95f0$var$getExternalSpaceKey = (contentInfo)=>contentInfo.slice(0, contentInfo.indexOf(':'));
const $742bec8a860b95f0$export$6a8851a6a483507b = (_, args, { network: network })=>{
    const { contentId: contentId, macroNode: { extensionKey: extensionKey, parameters: { macroParams: macroParamsString } } } = args;
    // Handles what logic to do based on the macro's extension key
    switch(extensionKey){
        case 'excerpt-include':
            const macroParams = JSON.parse(macroParamsString);
            const targetContentId = macroParams?._referencedContentId?.value ?? null;
            if (targetContentId !== null) return $742bec8a860b95f0$var$handleExcerptIncludeByTargetId(targetContentId, macroParams, network);
            else return $742bec8a860b95f0$var$handleExcerptInclude(contentId, macroParams, network);
        default:
            return Promise.resolve(null);
    }
};
const $742bec8a860b95f0$var$handleExcerptIncludeByTargetId = async (targetContentId, macroParams, network)=>{
    const response = await $742bec8a860b95f0$var$queryContentById(network, targetContentId);
    const targetPageAdfString = response?.data?.content?.nodes[0]?.body?.atlas_doc_format?.value ?? null;
    return $742bec8a860b95f0$var$formatResponse(targetPageAdfString, targetContentId, macroParams);
};
/**
 * Handles the payload logic for the excerpt include macro.
 *
 * This shotguns four queries, and then uses the response of whatever sticks
 * first. That response contains an ADF node that we parse to find the first
 * instance of an excerpt macro. We then return that macros content
 * stringified.
 *
 * @param contentId The excerpt include macro's content ID
 * @param macroParams The params object from the excerpt macro
 * @param cfetch cfetch
 */ const $742bec8a860b95f0$var$handleExcerptInclude = (contentId, macroParams, network)=>// We need to get the space key of the excerpt include macro so we can check
    // if the excerpt macro is from the same space.
    $742bec8a860b95f0$var$getSpaceKey(network, contentId).then((consumerContextResponse)=>{
        // This is either going to be of the pattern "${TITLE}",
        // "${SPACE_KEY}:${TITLE}", "/YYYY/MM/DD/${TITLE}",
        // "${SPACE_KEY}:/YYYY/MM/DD/${TITLE}". Unfortunately, we don't know
        // which we're getting, so we'll query them all.
        const targetPageInfo = macroParams?.['']?.value;
        const consumerSpaceKey = consumerContextResponse?.data?.content?.nodes?.[0]?.space?.key;
        // Just shotgun it, and grab one that sticks
        return Promise.all([
            // Page within current space "${TITLE}"
            $742bec8a860b95f0$var$queryContent(network, targetPageInfo, consumerSpaceKey, 'page'),
            // Blogpost within current space "/YYYY/MM/DD/${TITLE}"
            $742bec8a860b95f0$var$isPossiblyBlogpost(targetPageInfo) ? $742bec8a860b95f0$var$queryContent(network, $742bec8a860b95f0$var$getBlogpostTitle(targetPageInfo), consumerSpaceKey, 'blogpost') : Promise.resolve(null),
            // Page within outside space "${SPACE_KEY}:${TITLE}"
            $742bec8a860b95f0$var$isPossiblyExternalContent(targetPageInfo) ? $742bec8a860b95f0$var$queryContent(network, $742bec8a860b95f0$var$getExternalContentTitle(targetPageInfo), $742bec8a860b95f0$var$getExternalSpaceKey(targetPageInfo), 'page') : Promise.resolve(null),
            // Blogpost within outside space "${SPACE_KEY}:/YYYY/MM/DD/${TITLE}"
            $742bec8a860b95f0$var$isPossiblyExternalContent(targetPageInfo) && $742bec8a860b95f0$var$isPossiblyBlogpost($742bec8a860b95f0$var$getExternalContentTitle(targetPageInfo)) ? $742bec8a860b95f0$var$queryContent(network, $742bec8a860b95f0$var$getBlogpostTitle($742bec8a860b95f0$var$getExternalContentTitle(targetPageInfo)), $742bec8a860b95f0$var$getExternalSpaceKey(targetPageInfo), 'blogpost') : Promise.resolve(null)
        ]).then((responses)=>{
            // Go through the response and get the first valid adf string, and the associated contentId
            let targetPageAdfString = null;
            let targetContentId = null;
            responses.some((response)=>{
                targetPageAdfString = response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.value || null;
                if (targetPageAdfString) {
                    targetContentId = response?.data?.content?.nodes?.[0]?.id || null;
                    return true;
                }
            });
            return $742bec8a860b95f0$var$formatResponse(targetPageAdfString, targetContentId, macroParams);
        });
    });
const $742bec8a860b95f0$var$formatResponse = (targetPageAdfString, targetContentId, macroParams)=>{
    // If we didn't get anything, just return null
    if (!targetPageAdfString) return {
        payload: null,
        contentId: null
    };
    const targetAdf = JSON.parse(targetPageAdfString);
    // If a excerpt name is given, then we try to find the excerpt with name, otherwise we grab the first excerpt
    const excerptName = macroParams?.['name']?.value;
    const targetNodes = $742bec8a860b95f0$var$parseForTargetMacroNodeByExtensionKey('excerpt', targetAdf);
    let targetNodeContent = targetNodes[0]?.content;
    if (excerptName) targetNodeContent = targetNodes.find((node)=>node?.attrs?.parameters?.macroParams['name']?.value?.toUpperCase?.() === excerptName.toUpperCase())?.content;
    const payload = targetNodeContent ? JSON.stringify(targetNodeContent) : null;
    return {
        payload: payload,
        contentId: targetContentId
    };
};
module.exports["experimentalMacroMetadata"] = $742bec8a860b95f0$export$6a8851a6a483507b;

});

parcelRegister("1arfH", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $3en7c = parcelRequire("3en7c");

const $2d128bc66f1b6031$export$81bec6e38e8b706b = ({ cfetch: cfetch }, resource, init)=>cfetch(resource, {
        ...init,
        headers: {
            Accept: (0, $aBfpe.MediaType).JSON,
            ...init?.headers
        }
    }).then((response)=>response.json().catch((error)=>(0, $3en7c.throwErrorWithResponse)(error, response)));
module.exports["fetchJSON"] = $2d128bc66f1b6031$export$81bec6e38e8b706b;

});

parcelRegister("3en7c", function(module, exports) {

var $b4EKK = parcelRequire("b4EKK");

function $26ae9e969f6c4de1$export$8a24908f7aac7ac7(error, response) {
    throw (0, $b4EKK.getErrorWithResponse)(error, response);
}
module.exports["throwErrorWithResponse"] = $26ae9e969f6c4de1$export$8a24908f7aac7ac7;

});

parcelRegister("b4EKK", function(module, exports) {
function $9a7b0181c65e47f8$export$d882ca6820b0f4f3(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    return error;
}
module.exports["getErrorWithResponse"] = $9a7b0181c65e47f8$export$d882ca6820b0f4f3;

});

parcelRegister("bzfjI", function(module, exports) {

var $7AKam = parcelRequire("7AKam");


var $oDAuM = parcelRequire("oDAuM");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $6K7Y4 = parcelRequire("6K7Y4");

const $79883dd03c295974$export$12d1d7a32f123bdd = (0, $oDAuM.default);
const $79883dd03c295974$export$b91119ed144587a6 = (0, $7AKam.default);
const $79883dd03c295974$var$createEmptyResult = ({ loading: loading, error: error })=>({
        loading: loading,
        error: error,
        resolvedTarget: null,
        adfString: null,
        mediaToken: undefined
    });
const $79883dd03c295974$var$createErrorResult = (error)=>$79883dd03c295974$var$createEmptyResult({
        loading: false,
        error: error
    });
const $79883dd03c295974$var$getSupportedContentType = (content)=>{
    if (content.type === 'page' || content.type === 'blogpost') return content.type;
    return null;
};
const $79883dd03c295974$var$createResolvedContentResult = (content)=>{
    const contentType = $79883dd03c295974$var$getSupportedContentType(content);
    if (!contentType) return $79883dd03c295974$var$createErrorResult('invalid-content-type');
    const atlasDocFormat = content.body?.atlas_doc_format;
    return {
        loading: false,
        error: null,
        resolvedTarget: {
            contentId: content.id ?? '',
            title: content.title ?? '',
            spaceKey: content.space?.key ?? '',
            spaceId: content.space?.id ?? undefined,
            contentType: contentType
        },
        adfString: atlasDocFormat?.value ?? null,
        mediaToken: atlasDocFormat?.mediaToken?.token ?? undefined
    };
};
const $79883dd03c295974$var$loadingResult = $79883dd03c295974$var$createEmptyResult({
    loading: true,
    error: null
});
const $79883dd03c295974$var$missingTargetResult = $79883dd03c295974$var$createErrorResult('missing-target');
const $79883dd03c295974$var$networkFailureResult = $79883dd03c295974$var$createErrorResult('network-failure');
const $79883dd03c295974$var$notFoundResult = $79883dd03c295974$var$createErrorResult('not-found');
const $79883dd03c295974$var$emptyTitleQueryVariables = {
    rawSpaceKey: '',
    rawTitle: '',
    includeRaw: false,
    splitSpaceKey: '',
    splitTitle: '',
    includeSplit: false,
    blogSpaceKey: '',
    blogTitle: '',
    postingDay: '',
    includeBlog: false
};
const $79883dd03c295974$var$getTitleQueryContent = (titleData)=>{
    const contentByBlog = titleData?.blogContent?.nodes?.[0];
    if (contentByBlog) return contentByBlog;
    const contentBySplit = titleData?.splitContent?.nodes?.[0];
    if (contentBySplit) return contentBySplit;
    return titleData?.rawContent?.nodes?.[0] ?? null;
};
const $79883dd03c295974$export$d5a6c33bf44e8dde = (parsedTarget, hostSpaceKey)=>{
    const queryTarget = (0, $6K7Y4.getPageIncludeQueryTarget)(parsedTarget, hostSpaceKey);
    const shouldUseIdQuery = queryTarget.kind === 'by-id';
    const idQueryResult = (0, $jMyy4.useQueryInterop)($79883dd03c295974$export$12d1d7a32f123bdd, {
        variables: shouldUseIdQuery ? queryTarget.variables : {
            contentId: ''
        },
        skip: !shouldUseIdQuery,
        __callerPackage__: "page-include-macro"
    });
    const titleQueryResult = (0, $jMyy4.useQueryInterop)($79883dd03c295974$export$b91119ed144587a6, {
        variables: queryTarget.kind === 'by-title' ? queryTarget.variables : $79883dd03c295974$var$emptyTitleQueryVariables,
        skip: queryTarget.kind !== 'by-title',
        fetchPolicy: 'cache-first',
        __callerPackage__: "page-include-macro"
    });
    return (0, $cozmU.useMemo)(()=>{
        // If no valid target, we should not have reached here (caller handles missing-target)
        if (queryTarget.kind === 'missing-target') return $79883dd03c295974$var$missingTargetResult;
        if (shouldUseIdQuery) {
            const { data: idData, loading: idLoading, error: idError } = idQueryResult;
            if (idLoading) return $79883dd03c295974$var$loadingResult;
            if (idError) return $79883dd03c295974$var$networkFailureResult;
            const contentById = idData?.singleContent;
            return contentById ? $79883dd03c295974$var$createResolvedContentResult(contentById) : $79883dd03c295974$var$notFoundResult;
        }
        const { data: titleData, loading: titleLoading, error: titleError } = titleQueryResult;
        if (titleLoading) return $79883dd03c295974$var$loadingResult;
        if (titleError) return $79883dd03c295974$var$networkFailureResult;
        const contentByTitle = $79883dd03c295974$var$getTitleQueryContent(titleData);
        return contentByTitle ? $79883dd03c295974$var$createResolvedContentResult(contentByTitle) : $79883dd03c295974$var$notFoundResult;
    }, [
        queryTarget.kind,
        shouldUseIdQuery,
        idQueryResult,
        titleQueryResult
    ]);
};
module.exports["usePageIncludeMacroQuery"] = $79883dd03c295974$export$d5a6c33bf44e8dde;

});

parcelRegister("7AKam", function(module, exports) {
/**
 * @generated SignedSource<<1bce5b35349cd4550da965c94478b555>>
 * @relayHash 8f72766dbc3288a69e1f166ec6dfe741
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0
const $74df5cfe1a2e5d0a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogSpaceKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogTitle"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeBlog"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeRaw"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSplit"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawSpaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawTitle"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitSpaceKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitTitle"
    }, v10 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v11 = {
        "kind": "Literal",
        "name": "type",
        "value": "page"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v14 = [
        {
            "condition": "includeRaw",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "rawContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "rawSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "rawTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeSplit",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "splitContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "splitSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "splitTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeBlog",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "blogContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "postingDay",
                            "variableName": "postingDay"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "blogSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "blogTitle"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "blogpost"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "8f72766dbc3288a69e1f166ec6dfe741",
            "id": "4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByTitleQuery($rawSpaceKey:String!,$rawTitle:String!,$includeRaw:Boolean!,$splitSpaceKey:String!,$splitTitle:String!,$includeSplit:Boolean!,$blogSpaceKey:String!,$blogTitle:String!,$postingDay:String!,$includeBlog:Boolean!){rawContent:content(spaceKey:$rawSpaceKey,title:$rawTitle,type:\"page\",first:1)@include(if:$includeRaw){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},splitContent:content(spaceKey:$splitSpaceKey,title:$splitTitle,type:\"page\",first:1)@include(if:$includeSplit){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},blogContent:content(spaceKey:$blogSpaceKey,title:$blogTitle,type:\"blogpost\",postingDay:$postingDay,first:1)@include(if:$includeBlog){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}}"
        }
    };
}();
$74df5cfe1a2e5d0a$var$node.hash = "f95c0a76906580963b7866b01f678dd2";
var $74df5cfe1a2e5d0a$export$2e2bcd8739ae039 = $74df5cfe1a2e5d0a$var$node;
module.exports["default"] = $74df5cfe1a2e5d0a$export$2e2bcd8739ae039;

});

parcelRegister("oDAuM", function(module, exports) {
/**
 * @generated SignedSource<<1c0c89d79fe77d1b063869de36dc5dd5>>
 * @relayHash 29bcc67d3111f4f97c3c431cc81c9399
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53
const $8e0b9375d7694fe5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "29bcc67d3111f4f97c3c431cc81c9399",
            "id": "e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByIdQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByIdQuery($contentId:ID!){singleContent(id:$contentId){id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}"
        }
    };
}();
$8e0b9375d7694fe5$var$node.hash = "983fd7d5b2c3bedd36acf332a4d2a21e";
var $8e0b9375d7694fe5$export$2e2bcd8739ae039 = $8e0b9375d7694fe5$var$node;
module.exports["default"] = $8e0b9375d7694fe5$export$2e2bcd8739ae039;

});

parcelRegister("6K7Y4", function(module, exports) {
const $397b91bd2abb6c3a$export$bcd93dab64989992 = (macroParams)=>{
    const referencedContentId = macroParams?.['_referencedContentId']?.value ?? null;
    const parentId = macroParams?.['_parentId']?.value ?? null;
    // 1. Modern typed parameter (key is "")
    const typedValue = macroParams?.['']?.value?.trim();
    if (typedValue) return {
        location: typedValue,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // 2. Legacy pageTitle (takes precedence over "0")
    const pageTitle = macroParams?.['pageTitle']?.value?.trim();
    if (pageTitle) {
        const spaceKey = macroParams?.['spaceKey']?.value?.trim();
        const location = spaceKey ? `${spaceKey}:${pageTitle}` : pageTitle;
        return {
            location: location,
            referencedContentId: referencedContentId,
            parentId: parentId,
            error: null
        };
    }
    // 3. Legacy untyped default parameter "0"
    const legacyDefault = macroParams?.['0']?.value?.trim();
    if (legacyDefault) return {
        location: legacyDefault,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // No target configured
    return {
        location: null,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: 'missing-target'
    };
};
const $397b91bd2abb6c3a$var$extractContentIdFromTypedValue = (value)=>{
    const match = value.match(/confluence-content:\/\/[^/]+\/(\d+)/);
    return match ? match[1] : null;
};
const $397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX = /^(?:([\w]+):)?\/(\d{4}\/\d{2}\/\d{2})\/(.+)$/;
const $397b91bd2abb6c3a$var$isValidSpaceKey = (spaceKey)=>{
    if (!spaceKey) return false;
    if (spaceKey.startsWith('~')) return true;
    return spaceKey.length <= 255 && /^[A-Za-z0-9]+$/.test(spaceKey);
};
const $397b91bd2abb6c3a$var$parseSplitPageCandidate = (location)=>{
    const colonIdx = location.indexOf(':');
    if (colonIdx < 0) return null;
    const spaceKey = location.slice(0, colonIdx);
    const title = location.slice(colonIdx + 1);
    if (!$397b91bd2abb6c3a$var$isValidSpaceKey(spaceKey) || title.startsWith(' ')) return null;
    return {
        spaceKey: spaceKey,
        title: title
    };
};
const $397b91bd2abb6c3a$var$parseBlogPostCandidate = (location, hostSpaceKey)=>{
    const match = location.match($397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX);
    if (!match) return null;
    const spaceKey = match[1] || hostSpaceKey;
    const postingDay = match[2].replace(/\//g, '-');
    const title = match[3];
    if (!spaceKey || !title) return null;
    return {
        spaceKey: spaceKey,
        title: title,
        postingDay: postingDay
    };
};
const $397b91bd2abb6c3a$export$fc5689613a273ab4 = (parsedTarget, hostSpaceKey)=>{
    if (!parsedTarget.location) return {
        kind: 'missing-target'
    };
    const idFromTyped = $397b91bd2abb6c3a$var$extractContentIdFromTypedValue(parsedTarget.location);
    if (idFromTyped) return {
        kind: 'by-id',
        variables: {
            contentId: idFromTyped
        }
    };
    if (parsedTarget.referencedContentId) return {
        kind: 'by-id',
        variables: {
            contentId: parsedTarget.referencedContentId
        }
    };
    const rawTitle = parsedTarget.location.trim();
    if (!rawTitle) return {
        kind: 'missing-target'
    };
    const splitPageCandidate = $397b91bd2abb6c3a$var$parseSplitPageCandidate(rawTitle);
    const blogPostCandidate = $397b91bd2abb6c3a$var$parseBlogPostCandidate(rawTitle, hostSpaceKey);
    const includeRaw = !!hostSpaceKey;
    if (!includeRaw && !splitPageCandidate && !blogPostCandidate) return {
        kind: 'missing-target'
    };
    return {
        kind: 'by-title',
        variables: {
            rawSpaceKey: hostSpaceKey ?? '',
            rawTitle: rawTitle,
            includeRaw: includeRaw,
            splitSpaceKey: splitPageCandidate?.spaceKey ?? '',
            splitTitle: splitPageCandidate?.title ?? '',
            includeSplit: !!splitPageCandidate,
            blogSpaceKey: blogPostCandidate?.spaceKey ?? '',
            blogTitle: blogPostCandidate?.title ?? '',
            postingDay: blogPostCandidate?.postingDay ?? '',
            includeBlog: !!blogPostCandidate
        }
    };
};
module.exports["parseMacroTarget"] = $397b91bd2abb6c3a$export$bcd93dab64989992;
module.exports["getPageIncludeQueryTarget"] = $397b91bd2abb6c3a$export$fc5689613a273ab4;

});

parcelRegister("iNIw3", function(module, exports) {
const $2008359fb3515e18$export$38c6526d67de94bb = 'xen:macro';
const $2008359fb3515e18$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $2008359fb3515e18$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $2008359fb3515e18$export$46fc26821adc3495 = 'connectAddon';
const $2008359fb3515e18$export$95077f102dafd025 = 'migratedServerP2Addon';
const $2008359fb3515e18$export$981e47da3e2dfc13 = 'bodiedExtension';
const $2008359fb3515e18$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $2008359fb3515e18$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $2008359fb3515e18$export$bf4c163a4c708db1 = 'forgeDocUpdated';
const $2008359fb3515e18$export$973a451c50b864fd = 'atlassianMacroOutputType';
const $2008359fb3515e18$export$3551f8d01dfac8f1 = 'atlassianForgeInlineBodied';
module.exports["MODULE_NAME"] = $2008359fb3515e18$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $2008359fb3515e18$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $2008359fb3515e18$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $2008359fb3515e18$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $2008359fb3515e18$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $2008359fb3515e18$export$bf4c163a4c708db1;
module.exports["MACRO_OUTPUT_TYPE_PARAM"] = $2008359fb3515e18$export$973a451c50b864fd;
module.exports["FORGE_INLINE_BODIED_PARAM"] = $2008359fb3515e18$export$3551f8d01dfac8f1;

});

parcelRegister("liyuV", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $2E7zk = parcelRequire("2E7zk");


var $6mEZ3 = parcelRequire("6mEZ3");


var $7khND = parcelRequire("7khND");


var $eQyFc = parcelRequire("eQyFc");

const $100a3a77b8ac3a59$var$i18n = (0, $kSwu1.defineMessages)({
    displayAs: {
        id: "fabric-extension-lib.toc.displate-as",
        defaultMessage: "Display as"
    },
    separateSectionsBy: {
        id: "fabric-extension-lib.toc.separate-sections",
        defaultMessage: "Separate sections by"
    },
    bulletStyle: {
        id: "fabric-extension-lib.toc.bullet-style",
        defaultMessage: "Bullet style"
    },
    includeHeadingLevelsFrom: {
        id: "fabric-extension-lib.toc.include-heading-levels-from",
        defaultMessage: "Include heading levels from"
    },
    includeHeadingLevelsTo: {
        id: "fabric-extension-lib.toc.include-heading-levels-to",
        defaultMessage: "to"
    },
    includeSectionNumbers: {
        id: "fabric-extension-lib.toc.include-section-numbers",
        defaultMessage: "Include section numbers"
    },
    indentHeadingsLabel: {
        id: "fabric-extension-lib.toc.indent-headings.label",
        defaultMessage: "Indent headings"
    },
    indentHeadingsDescription: {
        id: "fabric-extension-lib.toc.indent-headings.description",
        defaultMessage: "Enter a valid CSS unit value"
    },
    includeHeadingsWithLabel: {
        id: "fabric-extension-lib.toc.include-headings-with.label",
        defaultMessage: "Include headings with:"
    },
    excludeHeadingsWithLabel: {
        id: "fabric-extension-lib.toc.exclude-headings-with.label",
        defaultMessage: "Exclude headings with:"
    },
    headingsWithDescription: {
        id: "fabric-extension-lib.toc.headings-with.description",
        defaultMessage: "Enter one or more keywords separated by | , or any regular expression"
    },
    cssClassNameLabel: {
        id: "fabric-extension-lib.toc.css-class-name.label",
        defaultMessage: "CSS class name"
    },
    cssClassNameDescription: {
        id: "fabric-extension-lib.toc.css-class-name.description",
        defaultMessage: "Enter a valid CSS attribute to customize the <code>&lt;div&gt;</code> surrounding this table of contents"
    },
    excludePDFExport: {
        id: "fabric-extension-lib.toc.exclude-pdf-export",
        defaultMessage: "Exclude PDF export"
    },
    verticalList: {
        id: "fabric-extension-lib.toc.vertical-list",
        defaultMessage: "Vertical list"
    },
    horizontalList: {
        id: "fabric-extension-lib.toc.horizontal-list",
        defaultMessage: "Horizontal list"
    },
    noneBulletStyle: {
        id: "fabric-extension-lib.toc.none-style",
        defaultMessage: "None"
    },
    bulletBulletStyle: {
        id: "fabric-extension-lib.toc.bullet-bullet-style",
        defaultMessage: "Bullet"
    },
    mixedBulletStyle: {
        id: "fabric-extension-lib.toc.mixed-bullet-style",
        defaultMessage: "Mixed"
    },
    circleBulletStyle: {
        id: "fabric-extension-lib.toc.circle-bullet-style",
        defaultMessage: "Circle"
    },
    squareBulletStyle: {
        id: "fabric-extension-lib.toc.square-bullet-style",
        defaultMessage: "Square"
    },
    numberBulletStyle: {
        id: "fabric-extension-lib.toc.number-bullet-style",
        defaultMessage: "Number"
    },
    customBulletStyle: {
        id: "fabric-extension-lib.toc.custom-bullet-style",
        defaultMessage: "Custom"
    },
    bracketSeparator: {
        id: "fabric-extension-lib.toc.bracket-separator",
        defaultMessage: "Bracket"
    },
    braceSeparator: {
        id: "fabric-extension-lib.toc.brace-separator",
        defaultMessage: "Brace"
    },
    pipeSeparator: {
        id: "fabric-extension-lib.toc.pipe-separator",
        defaultMessage: "Pipe"
    },
    basicTab: {
        id: "fabric-extension-lib.toc.basic-tab",
        defaultMessage: "Basic"
    },
    advancedTab: {
        id: "fabric-extension-lib.toc.advanced-tab",
        defaultMessage: "Advanced"
    },
    tocPlaceholder: {
        id: "fabric-extension-lib.toc.placeholder",
        defaultMessage: "A table of contents based on the headings of this content will appear here."
    },
    description: {
        id: "fabric-extension-lib.toc.description",
        defaultMessage: "Create a table of contents based on your content\u2019s headings"
    },
    title: {
        id: "fabric-extension-lib.toc.title",
        defaultMessage: "Table of contents"
    }
});
const $100a3a77b8ac3a59$var$numbers = (0, $kSwu1.defineMessages)({
    one: {
        id: "fabric-extension-lib.one",
        defaultMessage: "1"
    },
    two: {
        id: "fabric-extension-lib.two",
        defaultMessage: "2"
    },
    three: {
        id: "fabric-extension-lib.three",
        defaultMessage: "3"
    },
    four: {
        id: "fabric-extension-lib.four",
        defaultMessage: "4"
    },
    five: {
        id: "fabric-extension-lib.five",
        defaultMessage: "5"
    },
    six: {
        id: "fabric-extension-lib.six",
        defaultMessage: "6"
    }
});
const $100a3a77b8ac3a59$var$convertType = ({ acc: acc, value: value })=>{
    switch(value){
        case 'flat':
            acc['display-as'] = 'horizontal';
            break;
        case 'list':
            acc['display-as'] = 'vertical';
            break;
        case 'horizontal':
            acc['type'] = 'flat';
            break;
        case 'vertical':
            acc['type'] = 'list';
            break;
    }
};
const $100a3a77b8ac3a59$var$convertStyle = ({ transformType: transformType, acc: acc, value: value })=>{
    const key = transformType === 'transformBefore' ? 'bullet-styles' : 'style';
    switch(value){
        /*
      If the value coming in is "mixed," it implies the transformAfter case,
      i.e., the user selected "mixed" in the config panel. In this case, we need to
      set the `style` property to "default," as that's what's actually stored on the
      backend. The `style` property is also what's subsequently used in determining the
      CSS list style of the macro. Conversely, if the value is "default," it implies
      the transformBefore case, so we need to set the `bullet-styles` property to
      "mixed" to indicate that the list style should show mixed in the config panel.
      */ case 'mixed':
            acc['style'] = 'default';
            break;
        case 'default':
            acc['bullet-styles'] = 'mixed';
            break;
        case 'disc':
            acc['bullet-styles'] = 'bullet';
            break;
        case 'bullet':
            acc['style'] = 'disc';
            break;
        case 'circle':
            acc[key] = 'circle';
            break;
        case 'square':
            acc[key] = 'square';
            break;
        case 'none':
            acc[key] = 'none';
            break;
        case 'decimal':
            acc['bullet-styles'] = 'number';
            break;
        case 'number':
            acc['style'] = 'decimal';
            break;
    }
};
const $100a3a77b8ac3a59$var$convertSeparator = ({ transformType: transformType, acc: acc, value: value })=>{
    const key = transformType === 'transformBefore' ? 'separate-sections-by' : 'separator';
    switch(value){
        case 'brackets':
            acc[key] = 'brackets';
            break;
        case 'braces':
            acc[key] = 'braces';
            break;
        case 'pipe':
            acc[key] = 'pipe';
            break;
    }
};
const $100a3a77b8ac3a59$export$538b55b7ba195501 = (parameters)=>{
    if (!parameters || !parameters.macroParams) return {};
    const unwrappedParams = (0, $6mEZ3.unwrapMacroParams)(parameters.macroParams);
    return Object.keys(unwrappedParams).reduce((acc, key)=>{
        const value = unwrappedParams[key];
        switch(key){
            case 'type':
                $100a3a77b8ac3a59$var$convertType({
                    acc: acc,
                    value: value
                });
                break;
            case 'style':
                $100a3a77b8ac3a59$var$convertStyle({
                    transformType: 'transformBefore',
                    acc: acc,
                    value: value
                });
                break;
            case 'separator':
                $100a3a77b8ac3a59$var$convertSeparator({
                    transformType: 'transformBefore',
                    acc: acc,
                    value: value
                });
                break;
            case 'minLevel':
                acc['include-heading-levels-from'] = value;
                break;
            case 'maxLevel':
                acc['include-heading-levels-to'] = value;
                break;
            case 'outline':
                acc['include-section-numbers'] = value === 'true';
                break;
            case 'indent':
                acc['indent-headings-advanced'] = value;
                break;
            case 'include':
                acc['include-headings-advanced'] = value;
                break;
            case 'exclude':
                acc['exclude-headings-advanced'] = value;
                break;
            case 'class':
                acc['css-class-name-advanced'] = value;
                break;
            case 'printable':
                // "printable" technically means "include PDF export", but since changing the terminology
                // to "exclude PDF export" we need to inverse the evaluation
                acc['exclude-pdf-export-advanced'] = value !== 'true';
                break;
        }
        return acc;
    }, {});
};
const $100a3a77b8ac3a59$export$e075bbef54c4ffa = async (parameters)=>{
    const transformedParams = Object.keys(parameters).reduce((acc, key)=>{
        const value = parameters[key];
        switch(key){
            case 'display-as':
                $100a3a77b8ac3a59$var$convertType({
                    acc: acc,
                    value: value
                });
                break;
            case 'bullet-styles':
                $100a3a77b8ac3a59$var$convertStyle({
                    transformType: 'transformAfter',
                    acc: acc,
                    value: value
                });
                break;
            case 'separate-sections-by':
                $100a3a77b8ac3a59$var$convertSeparator({
                    transformType: 'transformAfter',
                    acc: acc,
                    value: value
                });
                break;
            case 'include-heading-levels-from':
                acc['minLevel'] = value;
                break;
            case 'include-heading-levels-to':
                acc['maxLevel'] = value;
                break;
            case 'include-section-numbers':
                acc['outline'] = JSON.stringify(value);
                break;
            case 'indent-headings-advanced':
                acc['indent'] = value;
                break;
            case 'include-headings-advanced':
                acc['include'] = value;
                break;
            case 'exclude-headings-advanced':
                acc['exclude'] = value;
                break;
            case 'css-class-name-advanced':
                acc['class'] = value;
                break;
            case 'exclude-pdf-export-advanced':
                acc['printable'] = value === false ? 'true' : 'false';
                break;
        }
        return acc;
    }, {});
    const wrappedParams = (0, $6mEZ3.wrapMacroParams)(transformedParams);
    return {
        macroParams: wrappedParams
    };
};
const $100a3a77b8ac3a59$export$1eb70cd9e03f9068 = ({ macro: macro, pageContext: pageContext, extensionHandlers: extensionHandlers, openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, macroBrowserConfig: macroBrowserConfig, editorAPI: editorAPI, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent, intl: intl, onCompleteCallback: onCompleteCallback, isLivePage: isLivePage })=>{
    const title = intl.formatMessage($100a3a77b8ac3a59$var$i18n.title);
    const description = intl.formatMessage($100a3a77b8ac3a59$var$i18n.description);
    macro.title = title;
    macro.description = description;
    return {
        type: 'com.atlassian.confluence.macro.core',
        key: 'toc',
        title: title,
        description: description,
        icons: (0, $eQyFc.buildIconObject)(macro),
        documentationUrl: 'https://confluence.atlassian.com/display/ConfCloud/Table+of+Contents+Macro',
        modules: {
            quickInsert: (0, $2E7zk.createQuickInsertModule)(macro, pageContext, openMacroBrowserForInitialConfiguration, editorAPI, intl, macroBrowserConfig, editorActions, createAnalyticsEvent, onCompleteCallback, isLivePage),
            nodes: {
                default: {
                    type: 'extension',
                    render: ()=>{
                        const extensionHandler = extensionHandlers['com.atlassian.confluence.macro.core'];
                        return Promise.resolve((extension)=>{
                            if (typeof extensionHandler === 'function') return extensionHandler(extension.node, {
                                references: extension.references
                            });
                            return extensionHandler.render(extension.node, {
                                references: extension.references
                            });
                        });
                    },
                    update: (_, actions)=>{
                        return new Promise(()=>{
                            actions.editInContextPanel($100a3a77b8ac3a59$export$538b55b7ba195501, $100a3a77b8ac3a59$export$e075bbef54c4ffa);
                        });
                    },
                    getFieldsDefinition: (params)=>{
                        // Safely handle null/undefined params by using empty objects as fallback
                        // This ensures the config panel can render even if parameters are corrupted
                        const safeParams = params || {
                            macroParams: {}
                        };
                        const macroParams = safeParams.macroParams || {};
                        const typeValue = macroParams['type']?.value;
                        const includeHeadingsOptions = [
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.one),
                                value: '1'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.two),
                                value: '2'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.three),
                                value: '3'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.four),
                                value: '4'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.five),
                                value: '5'
                            },
                            {
                                label: intl.formatMessage($100a3a77b8ac3a59$var$numbers.six),
                                value: '6'
                            }
                        ];
                        return Promise.resolve([
                            {
                                type: 'tab-group',
                                name: 'tabGroup',
                                label: 'ToC Tab Group',
                                defaultTab: 'basic',
                                fields: [
                                    {
                                        type: 'tab',
                                        label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.basicTab),
                                        name: 'basic',
                                        fields: [
                                            {
                                                name: 'display-as',
                                                type: 'enum',
                                                style: 'radio',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.displayAs),
                                                isMultiple: false,
                                                defaultValue: 'vertical',
                                                items: [
                                                    {
                                                        label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.verticalList),
                                                        value: 'vertical'
                                                    },
                                                    {
                                                        label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.horizontalList),
                                                        value: 'horizontal'
                                                    }
                                                ]
                                            },
                                            ...typeValue === 'flat' ? [
                                                {
                                                    name: 'separate-sections-by',
                                                    label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.separateSectionsBy),
                                                    type: 'enum',
                                                    style: 'select',
                                                    isMultiple: false,
                                                    defaultValue: 'brackets',
                                                    items: [
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.bracketSeparator),
                                                            value: 'brackets',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.BracketSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.braceSeparator),
                                                            value: 'braces',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.BraceSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.pipeSeparator),
                                                            value: 'pipe',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.PipeSVG)
                                                            })
                                                        }
                                                    ]
                                                }
                                            ] : [
                                                {
                                                    name: 'bullet-styles',
                                                    label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.bulletStyle),
                                                    type: 'enum',
                                                    style: 'select',
                                                    isMultiple: false,
                                                    defaultValue: !macroParams['style'] && 'mixed',
                                                    placeholder: ![
                                                        'none',
                                                        'mixed',
                                                        'bullet',
                                                        'circle',
                                                        'square',
                                                        'number'
                                                    ].includes(macroParams['style']) && intl.formatMessage($100a3a77b8ac3a59$var$i18n.customBulletStyle),
                                                    items: [
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.noneBulletStyle),
                                                            value: 'none',
                                                            icon: null
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.mixedBulletStyle),
                                                            value: 'mixed',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.DiscSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.bulletBulletStyle),
                                                            value: 'bullet',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.BulletSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.circleBulletStyle),
                                                            value: 'circle',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.CircleSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.squareBulletStyle),
                                                            value: 'square',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.SquareSVG)
                                                            })
                                                        },
                                                        {
                                                            label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.numberBulletStyle),
                                                            value: 'number',
                                                            icon: (0, $7khND.DropdownIcon)({
                                                                icon: (0, $7khND.NumberedSVG)
                                                            })
                                                        }
                                                    ]
                                                }
                                            ],
                                            {
                                                name: 'include-heading-levels-from',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.includeHeadingLevelsFrom),
                                                type: 'enum',
                                                style: 'select',
                                                isMultiple: false,
                                                defaultValue: '1',
                                                items: includeHeadingsOptions
                                            },
                                            {
                                                name: 'include-heading-levels-to',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.includeHeadingLevelsTo),
                                                type: 'enum',
                                                style: 'select',
                                                isMultiple: false,
                                                defaultValue: '6',
                                                items: includeHeadingsOptions
                                            },
                                            {
                                                name: 'include-section-numbers',
                                                type: 'boolean',
                                                style: 'checkbox',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.includeSectionNumbers),
                                                defaultValue: false
                                            }
                                        ]
                                    },
                                    {
                                        type: 'tab',
                                        label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.advancedTab),
                                        name: 'advanced',
                                        fields: [
                                            {
                                                name: 'indent-headings-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.indentHeadingsLabel),
                                                isRequired: false,
                                                description: intl.formatMessage($100a3a77b8ac3a59$var$i18n.indentHeadingsDescription),
                                                type: 'string'
                                            },
                                            {
                                                name: 'include-headings-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.includeHeadingsWithLabel),
                                                isRequired: false,
                                                description: intl.formatMessage($100a3a77b8ac3a59$var$i18n.headingsWithDescription),
                                                type: 'string'
                                            },
                                            {
                                                name: 'exclude-headings-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.excludeHeadingsWithLabel),
                                                isRequired: false,
                                                description: intl.formatMessage($100a3a77b8ac3a59$var$i18n.headingsWithDescription),
                                                type: 'string'
                                            },
                                            {
                                                name: 'css-class-name-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.cssClassNameLabel),
                                                isRequired: false,
                                                description: intl.formatMessage($100a3a77b8ac3a59$var$i18n.cssClassNameDescription),
                                                type: 'string'
                                            },
                                            {
                                                name: 'exclude-pdf-export-advanced',
                                                label: intl.formatMessage($100a3a77b8ac3a59$var$i18n.excludePDFExport),
                                                defaultValue: false,
                                                style: 'checkbox',
                                                type: 'boolean'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]);
                    }
                }
            }
        }
    };
};
module.exports["tableOfContentsExtension"] = $100a3a77b8ac3a59$export$1eb70cd9e03f9068;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("iS5Ay", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("8Utl8", function(module, exports) {
/* renderTocDirect.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7vK9E = parcelRequire("7vK9E");


var $6mKj3 = parcelRequire("6mKj3");


var $79mJ9 = parcelRequire("79mJ9");


var $d3Yd3 = parcelRequire("d3Yd3");

const $be5130bdb4a81bdd$export$b66a2f2b47bf6353 = 'toc-empty-item';
const $be5130bdb4a81bdd$var$styles = {
    link: "_2sNsIg20Hp"
};
function $be5130bdb4a81bdd$var$normalizeHeadings(elements) {
    const minLevel = elements.reduce((min, el)=>Math.min(min, el?.attrs?.level ?? 6), Infinity);
    if (elements[0]?.attrs?.level === minLevel) return elements;
    return [
        {
            type: 'toc',
            attrs: {
                level: minLevel
            },
            content: [
                {
                    text: $be5130bdb4a81bdd$export$b66a2f2b47bf6353,
                    type: 'string'
                }
            ]
        },
        ...elements
    ];
}
const $be5130bdb4a81bdd$export$36615f8ab4c6a228 = (headerElements, renderer)=>{
    if (headerElements.length === 0) return renderer.mergeItems([]);
    const headings = $be5130bdb4a81bdd$var$normalizeHeadings(headerElements);
    const stack = [];
    const rootResults = [];
    const counters = [];
    function close() {
        const frame = stack.pop();
        const children = renderer.mergeItems(frame.childResults);
        const result = renderer.renderItem(frame.heading, stack.length, children); // Use index access instead of `Array.prototype.at(-1)` because the latter
        // is unsupported in Safari < 15.4 (lint: no-restricted-syntax).
        const parent = stack.length > 0 ? stack[stack.length - 1] : undefined;
        if (parent) parent.childResults.push(result);
        else rootResults.push(result);
    }
    for (const entity of headings){
        const level = entity.attrs?.level ?? 1;
        while(stack.length > 0 && stack[stack.length - 1].level >= level)close();
        if (counters.length <= stack.length) counters.push(0);
        counters[stack.length]++;
        counters.length = stack.length + 1;
        const outline = counters.map(String);
        const isEmpty = entity.content?.[0]?.text === $be5130bdb4a81bdd$export$b66a2f2b47bf6353;
        const heading = {
            content: entity.content ?? [],
            level: level,
            id: isEmpty ? $be5130bdb4a81bdd$export$b66a2f2b47bf6353 : entity.attrs?.id ?? '',
            outline: outline
        };
        stack.push({
            level: level,
            heading: heading,
            childResults: []
        });
    }
    while(stack.length > 0)close();
    return renderer.mergeItems(rootResults);
};
function $be5130bdb4a81bdd$var$renderContent(content, cloudId, userId) {
    const nodes = content.filter(Boolean);
    if (nodes.length === 0) return null;
     // Only collapse to a string when the text nodes have NO marks. This preserves
    // formatting marks (bold, italic, code, link, etc.) inside headings.
    const isFastPathEligible = (0, $6mKj3.expVal)('confluence_toc_render_perf', 'isEnabled', false) ? nodes.every((n)=>n.type === 'hardBreak' || n.type === 'text' && (!n.marks || n.marks.length === 0)) : nodes.every((n)=>n.type === 'text' || n.type === 'hardBreak');
    if (isFastPathEligible) return nodes.map((n)=>n.type === 'hardBreak' ? '' : n.text ?? '').join('');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79mJ9.MiniRenderer), {
        adfEntities: content,
        cloudId: cloudId,
        userId: userId
    });
}
function $be5130bdb4a81bdd$var$renderLink(heading, outline, cloudId, userId, shouldExpandParentExpandsOnScroll) {
    const outlineStr = heading.outline.join('.');
    const href = `#${encodeURIComponent(heading.id)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        testId: "toc-item-body",
        "data-outline": outlineStr,
        href: href,
        onClick: ()=>(0, $d3Yd3.scrollToHeader)(href, shouldExpandParentExpandsOnScroll),
        className: (0, $hekY6.default)([
            $be5130bdb4a81bdd$var$styles.link
        ])
    }, outline === 'true' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, outlineStr, " "), $be5130bdb4a81bdd$var$renderContent(heading.content, cloudId, userId));
}
function $be5130bdb4a81bdd$var$renderFlatToc(headerelements, outline, separators, cloudId, userId, shouldExpandParentExpandsOnScroll) {
    const flatItems = $be5130bdb4a81bdd$export$36615f8ab4c6a228(headerelements, {
        renderItem: (heading, _depth, children)=>{
            if (heading.id === $be5130bdb4a81bdd$export$b66a2f2b47bf6353) return children ?? [];
            return [
                $be5130bdb4a81bdd$var$renderLink(heading, outline, cloudId, userId, shouldExpandParentExpandsOnScroll),
                ...children ?? []
            ];
        },
        mergeItems: (merged)=>merged.flat()
    });
    if (flatItems.length === 0) return null;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "flat-style-toc-item-container",
        className: "toc-item-container"
    }, flatItems.map((item, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: "toc-separator"
        }, idx === 0 ? separators[0] : separators[1]), item)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: "toc-separator"
    }, separators[2])));
}
function $be5130bdb4a81bdd$var$renderListToc(headerelements, outline, cssliststyle, csslistindent, cloudId, userId, shouldExpandParentExpandsOnScroll) {
    return $be5130bdb4a81bdd$export$36615f8ab4c6a228(headerelements, {
        renderItem: (heading, _depth, children)=>{
            const isEmpty = heading.id === $be5130bdb4a81bdd$export$b66a2f2b47bf6353;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
                key: heading.outline.join('.'),
                "data-testid": "list-style-toc-item-container",
                style: {
                    listStyle: isEmpty ? 'none' : cssliststyle ?? 'default'
                }
            }, !isEmpty && $be5130bdb4a81bdd$var$renderLink(heading, outline, cloudId, userId, shouldExpandParentExpandsOnScroll), children);
        },
        mergeItems: (listItems)=>{
            if (listItems.length === 0) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
                "data-testid": "list-style-toc-level-container",
                style: {
                    paddingLeft: csslistindent
                }
            }, listItems);
        }
    });
}
const $be5130bdb4a81bdd$export$dcb83f9ad409c737 = (tocOptions, separators, cloudId, userId, shouldExpandParentExpandsOnScroll = false)=>{
    const { headerelements: headerelements, structure: structure, outline: outline, cssliststyle: cssliststyle, csslistindent: csslistindent } = tocOptions;
    if (!headerelements?.length) return null;
    if (structure === 'flat') return $be5130bdb4a81bdd$var$renderFlatToc(headerelements, outline, separators, cloudId, userId, shouldExpandParentExpandsOnScroll);
    return $be5130bdb4a81bdd$var$renderListToc(headerelements, outline, cssliststyle, csslistindent, cloudId, userId, shouldExpandParentExpandsOnScroll);
};
module.exports["EmptyTocItem"] = $be5130bdb4a81bdd$export$b66a2f2b47bf6353;
module.exports["renderReducedToc"] = $be5130bdb4a81bdd$export$dcb83f9ad409c737;

});

parcelRegister("79mJ9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");


var $g2dpd = parcelRequire("g2dpd");

const $6b94f1cb3b6ea4db$export$c28721872d45d644 = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { adfEntities: adfEntities, cloudId: cloudId, userId: userId } = t0;
    let t1;
    if ($[0] !== adfEntities || $[1] !== cloudId || $[2] !== userId) {
        let t2;
        if ($[4] !== cloudId || $[5] !== userId) {
            t2 = (el, idx)=>{
                switch(el?.type){
                    case "date":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g2dpd.DateLoader), {
                            timestamp: el?.attrs?.timestamp
                        });
                    case "emoji":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g2dpd.EmojiLoader), {
                            id: el?.attrs?.id,
                            shortName: el?.attrs?.shortName,
                            cloudId: cloudId,
                            userId: userId
                        });
                    case "mention":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g2dpd.MentionLoader), {
                            name: el?.attrs?.text,
                            isUserSelf: el?.attrs?.id === userId
                        });
                    case "status":
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g2dpd.StatusLoader), {
                            text: el?.attrs?.text,
                            color: el?.attrs?.color,
                            statusStyle: el?.attrs?.style,
                            isBold: el?.attrs?.style === "bold"
                        });
                    default:
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                            as: "span",
                            color: "inherit",
                            size: "large",
                            key: idx
                        }, el?.text || el?.attrs?.text || el?.attrs?.__confluenceMetadata?.contentTitle || "");
                }
            };
            $[4] = cloudId;
            $[5] = userId;
            $[6] = t2;
        } else t2 = $[6];
        t1 = adfEntities.map(t2);
        $[0] = adfEntities;
        $[1] = cloudId;
        $[2] = userId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "span",
            color: "inherit",
            size: "large"
        }, t1);
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["MiniRenderer"] = $6b94f1cb3b6ea4db$export$c28721872d45d644;

});

parcelRegister("d3Yd3", function(module, exports) {

var $3iED4 = parcelRequire("3iED4");


var $6mKj3 = parcelRequire("6mKj3");

const $1593092db348217b$export$6a9dfcea43015ca7 = (id, shouldExpandParentExpandsOnScroll = false)=>{
    if (!id) return;
    const escapedId = id.replace(/[.:;*+?^$!@$^&~%{}()=/|[\]\\]/g, '\\$&');
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const pmodeContent = document.querySelector(`#presenter-mode-container ${escapedId}`);
    if (pmodeContent) pmodeContent.scrollIntoView();
    // Extract the id from the href (remove the # prefix if present)
    const targetId = id.startsWith('#') ? id.substring(1) : id;
    const decodedId = decodeURIComponent(targetId);
    // For normal page view, find the element by id
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const targetElement = document.getElementById(decodedId);
    if (targetElement) {
        if (shouldExpandParentExpandsOnScroll && (0, $6mKj3.expVal)('platform_editor_fix_toc_scroll_heading_in_expand', 'isEnabled', false)) // Open any collapsed ancestor expand(s) before scrolling to the heading.
        (0, $3iED4.expandAllParentsThenScroll)(targetElement);
        // Move focus to the target element for screen reader accessibility
        targetElement.focus();
    }
};
module.exports["scrollToHeader"] = $1593092db348217b$export$6a9dfcea43015ca7;

});

parcelRegister("g2dpd", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $151bbc40c0c4a388$export$25f69473ce9bec3b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Sb9EH",
    name: 'DateLoader',
    loader: async ()=>(await (parcelRequire("4WITQ"))).DateComponent
});

const $151bbc40c0c4a388$export$a6d57304049a7a43 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zhXsC",
    name: 'EmojiLoader',
    loader: async ()=>(await (parcelRequire("8KLwI"))).EmojiComponent
});

const $151bbc40c0c4a388$export$d85b1a715d2d313e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4AxQj",
    name: 'EmojiLoader',
    loader: async ()=>(await (parcelRequire("2GLbB"))).MentionComponent
});

const $151bbc40c0c4a388$export$498fc322979ddd04 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LHr7Y",
    name: 'StatusLoader',
    loader: async ()=>(await (parcelRequire("94CVU"))).StatusComponent
});
module.exports["DateLoader"] = $151bbc40c0c4a388$export$25f69473ce9bec3b;
module.exports["EmojiLoader"] = $151bbc40c0c4a388$export$a6d57304049a7a43;
module.exports["MentionLoader"] = $151bbc40c0c4a388$export$d85b1a715d2d313e;
module.exports["StatusLoader"] = $151bbc40c0c4a388$export$498fc322979ddd04;

});


//# sourceMappingURL=TableOfContents.b6321c83.js.map
